webpackJsonp([0],[
/* 0 */,
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);

var firebaseApp = __WEBPACK_IMPORTED_MODULE_0_firebase___default.a.initializeApp({
  apiKey: 'AIzaSyAWdzEQdR4jM_wEfz9xzf_fak3kE9dtESU',
  authDomain: 'takeitmakeit-b7ef1.firebaseapp.com',
  databaseURL: 'https://takeitmakeit-b7ef1.firebaseio.com',
  projectId: 'takeitmakeit-b7ef1',
  storageBucket: 'takeitmakeit-b7ef1.appspot.com',
  messagingSenderId: '768082669515'
});

/* harmony default export */ __webpack_exports__["a"] = (firebaseApp);

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(77)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(33),
  /* template */
  __webpack_require__(123),
  /* scopeId */
  "data-v-ef02e72a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(63)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(109),
  /* scopeId */
  "data-v-28b1f330",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports) {

module.exports = [
	{
		"type": "mountain",
		"name": "lidongo",
		"coordinates": [
			18.1408739,
			59.3503239
		],
		"y": -2,
		"options": {
			"color": "blue"
		}
	},
	{
		"type": "mountain",
		"name": "gardet",
		"coordinates": [
			18.117485,
			59.336341
		],
		"y": -100,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "danderyd",
		"coordinates": [
			18.051567,
			59.383059
		],
		"y": 500,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "centralLidingo",
		"coordinates": [
			18.118858,
			59.36172
		],
		"y": 300,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "hagaparken",
		"coordinates": [
			18.01792,
			59.35629
		],
		"y": 600,
		"options": {
			"color": "blue"
		}
	},
	{
		"type": "mountain",
		"name": "friends",
		"coordinates": [
			18.00006,
			59.37274
		],
		"y": 600,
		"options": {
			"color": "pink"
		}
	},
	{
		"type": "mountain",
		"name": "essinge",
		"coordinates": [
			17.99182,
			59.32145
		],
		"y": 600,
		"options": {
			"color": "blue"
		}
	},
	{
		"type": "mountain",
		"name": "bromma",
		"coordinates": [
			17.96281,
			59.32951
		],
		"y": 500,
		"options": {
			"color": "purple"
		}
	},
	{
		"type": "mountain",
		"name": "liljeholmen",
		"coordinates": [
			18.01577,
			59.31195
		],
		"y": 500,
		"options": {
			"color": "pink"
		}
	}
];

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Arex__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Arex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Arex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WinnerFeed__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_WinnerFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_WinnerFeed__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'start',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Start___default.a
  }, {
    path: '/arex',
    name: 'arex',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Arex___default.a
  }, {
    path: '/winners',
    name: 'winners',
    component: __WEBPACK_IMPORTED_MODULE_4__components_WinnerFeed___default.a
  }]
}));

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Db__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_spots_update_json__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__json_spots_update_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__json_spots_update_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_new_areas_json__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__json_new_areas_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__json_new_areas_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_objects_json__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__json_objects_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__json_objects_json__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    showMenu: false,
    user: null,
    userCheck: false,
    userLocation: {
      lat: 59.334591,
      lng: 18.063240
    },
    needsReload: false,
    userPhotos: [],
    userScore: null,
    locationError: false,
    userNotices: [],
    userNoticesRead: true,
    showAuth: true,
    showLogin: true,
    showingPhotoUpload: false,
    points: 0,
    spots: [],
    visitedSpots: [],
    areas: [],
    currentArea: null,
    currentAreaName: null,
    atSpot: [null, 0],
    atSpotPhotos: [],
    atSpotPhotosLoaded: false,
    atSpotWinner: null,
    uploadingPhoto: false,
    waiting: [],
    battleWinner: null,
    uploadingPhotoProgress: 0,
    interupt: null,
    singlePhoto: null,
    infoMenu: false,
    bugReport: false,
    textPageContent: null,
    voteOnPhoto: null,
    highscore: null,
    highscoreList: null,
    justVoted: 'no',
    userVisitedSpots: [],
    threeDObjects: [],
    showAgreement: false,
    hasBeenToStart: false,
    wasAtAr: false,
    locationHasBeenLoaded: false,
    spotAtDistance: null
  },
  getters: {
    showingOverlay: function showingOverlay(state) {
      return state.atSpot[0] !== null;
    },
    fullScore: function fullScore(state) {
      return state.userScore + state.userVisitedSpots.length * 10;
    },
    userHasPhotoAtSpot: function userHasPhotoAtSpot(state) {
      var photos = state.userPhotos;
      var spot = state.atSpot;
      var userphoto = photos.filter(function (a) {
        if (a.spot === spot[0]) {
          return true;
        }
        return false;
      });
      return userphoto.length > 0;
    }
  },
  mutations: {
    setNeedsReload: function setNeedsReload(state, needs) {
      state.needsReload = needs;
    },
    updateSpotAtDistance: function updateSpotAtDistance(state, show) {
      state.spotAtDistance = show;
    },
    setLocationHasBeenLoaded: function setLocationHasBeenLoaded(state, show) {
      state.locationHasBeenLoaded = show;
    },
    setWasAtAr: function setWasAtAr(state, show) {
      state.wasAtAr = show;
    },
    setHasBeenToStart: function setHasBeenToStart(state, show) {
      state.hasBeenToStart = show;
    },
    setShowAgreement: function setShowAgreement(state, show) {
      state.showAgreement = show;
    },
    updateHighscore: function updateHighscore(state, list) {
      state.highscoreList = list;
    },
    updateUserVisitedSpots: function updateUserVisitedSpots(state, spots) {
      state.userVisitedSpots = spots;
    },
    importThreeDObjects: function importThreeDObjects(state, objs) {
      state.threeDObjects = __WEBPACK_IMPORTED_MODULE_5__json_objects_json___default.a;
    },
    setUserScore: function setUserScore(state, score) {
      state.userScore = score;
    },
    setUserPhotos: function setUserPhotos(state, photos) {
      state.userPhotos = photos;
    },
    setJustVoted: function setJustVoted(state, what) {
      state.justVoted = what;
    },
    showHighscore: function showHighscore(state, show) {
      state.highscore = show;
    },
    updateVoteOnPhoto: function updateVoteOnPhoto(state, photo) {
      state.voteOnPhoto = photo;
    },
    openTextPage: function openTextPage(state, html) {
      state.textPageContent = html;
    },
    changeShowMenu: function changeShowMenu(state, at) {
      state.showMenu = at;
    },
    showBugReport: function showBugReport(state, show) {
      state.bugReport = show;
    },
    changeUserLocation: function changeUserLocation(state, location) {
      state.userLocation = location;
    },
    changeLocationError: function changeLocationError(state, hasError) {
      state.locationError = hasError;
    },
    showAuth: function showAuth(state, show) {
      state.showAuth = show;
    },
    showLogin: function showLogin(state, show) {
      state.showLogin = show;
    },
    setSinglePhoto: function setSinglePhoto(state, photo) {
      state.singlePhoto = photo;
    },
    showInfoMenu: function showInfoMenu(state, show) {
      state.infoMenu = show;
    },
    showingPhotoUpload: function showingPhotoUpload(state, show) {
      state.showingPhotoUpload = show;
    },
    updateUser: function updateUser(state, user) {
      state.user = user;
    },
    updateUserCheck: function updateUserCheck(state, userCheck) {
      state.userCheck = userCheck;
    },
    setCurrentArea: function setCurrentArea(state, areaKey) {
      state.currentArea = areaKey;
    },
    setCurrentAreaName: function setCurrentAreaName(state, areaName) {
      state.currentAreaName = areaName;
    },
    setAtSpot: function setAtSpot(state, spotname) {
      state.atSpot = spotname;
    },
    setAtSpotWinner: function setAtSpotWinner(state, winner) {
      state.atSpotWinner = winner;
    },
    setBattleWinner: function setBattleWinner(state, winner) {
      state.battleWinner = winner;
    },
    setAtSpotPhotos: function setAtSpotPhotos(state, spotPhotos) {
      state.atSpotPhotos = spotPhotos;
    },
    setAtSpotPhotosLoaded: function setAtSpotPhotosLoaded(state, bol) {
      state.atSpotPhotosLoaded = bol;
    },
    addAtSpotPhotos: function addAtSpotPhotos(state, photo) {
      state.atSpotPhotos.push(photo);
    },
    addNewWaiting: function addNewWaiting(state, waitingPhoto) {
      state.waiting.push(waitingPhoto);
    },
    updateWaiting: function updateWaiting(state, waitingPhoto) {
      state.waiting = state.waiting.map(function (a, index) {
        if (index === waitingPhoto.key) {
          return waitingPhoto.val;
        } else {
          return a;
        }
      });
    },
    updateNotices: function updateNotices(state, notices) {
      state.userNotices = notices;
    },
    logout: function logout(state) {
      state.user = null;
    },
    interupt: function interupt(state, obj) {
      state.interupt = obj;
    }
  },
  actions: {
    viewSinglePhoto: function viewSinglePhoto(context, payload) {
      context.commit('setSinglePhoto', payload);
    },
    setAtSpot: function setAtSpot(context, payLoad) {
      context.commit('setAtSpot', [payLoad.spotname, payLoad.distance]);

      if (payLoad.spotname !== null) {
        __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('/photos/' + context.state.atSpot[0]).orderByChild('score').limitToLast(29).once('value').then(function (snapshot) {
          var photos = [];
          snapshot.forEach(function (childSnapshot) {
            var val = childSnapshot.val();
            photos.push({
              filename: val.filename,
              time: val.time,
              url: val.url,
              thumburl: val.thumburl,
              user: val.user,
              username: val.username,
              score: val.score,
              voteCount: val.voteCount
            });
          });
          context.commit('setAtSpotPhotos', photos);
          context.commit('setAtSpotPhotosLoaded', true);
        });
        context.dispatch('fetchWinner');
      } else {
        context.commit('setAtSpotPhotos', []);
        context.commit('setAtSpotWinner', null);
        context.commit('setAtSpotPhotosLoaded', false);
      }
    },
    reportABug: function reportABug(context, payLoad) {
      var report = {
        text: payLoad.text,
        user: context.state.user.displayName,
        userid: context.state.user.uid,
        time: { '.sv': 'timestamp' }
      };
      var newReport = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('reports/').push();
      newReport.set(report);
      context.commit('interupt', 'Tack!');
      context.commit('showBugReport', false);
    },
    fetchfromApi: function fetchfromApi(context) {
      console.log('test');
    },
    logout: function logout(context) {
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].auth().signOut().then(function () {
        context.commit('logout');
        window.setTimeout(function () {
          window.location.reload();
        }, 2000);
      }).catch(function (error) {
        console.log('Någonting gick fel när du loggades ut: ', error);
      });
    },
    uploadPhoto: function uploadPhoto(context, payLoad) {
      var storageRef = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].storage().ref();
      var photoId = payLoad.fileName + Math.floor(Date.now() / 1000);
      var uploadTask = storageRef.child('photos/' + photoId).put(payLoad.file);
      context.state.uploadingPhoto = true;
      uploadTask.on('state_changed', function (snapshot) {
        var progress = snapshot.bytesTransferred / snapshot.totalBytes * 100;
        context.state.uploadingPhotoProgress = progress;
        switch (snapshot.state) {
          case 'paused':
            console.log('Upload is paused');
            break;
          case 'running':
            break;
        }
      }, function (error) {
        context.state.uploadingPhoto = false;
        switch (error.code) {
          case 'storage/unauthorized':
            console.log('unauthorized to upload image');
            break;
          case 'storage/canceled':
            console.log('User canceled upload image');
            break;
          case 'storage/unknown':
            console.log('Unknown error');
            break;
        }
      }, function () {
        var uploadThumbTask = storageRef.child('thumbs/' + payLoad.fileName).put(payLoad.thumb);
        uploadThumbTask.on('state_changed', function (snapshotThumb) {}, function (error) {
          switch (error.code) {
            case 'storage/unauthorized':
              console.log('unauthorized to upload thumb image');
              break;
            case 'storage/canceled':
              console.log('User canceled upload thumb image');
              break;
            case 'storage/unknown':
              console.log('Unknown error, thumb image');
              break;
          }
        }, function () {
          context.state.uploadingPhoto = false;
          var downloadUrl = uploadTask.snapshot.downloadURL;
          var thumbUrl = uploadThumbTask.snapshot.downloadURL;


          if (payLoad.isFirst === true) {
            context.commit('interupt', { html: 'Snyggt! Ditt foto är med i Exhibition Stockholm<h6>Så fort minst fem personer har röstat på din bild är den med och tävlar.</h6><h5>+20 poäng</h5>', type: 'win' });
          } else {
            context.commit('interupt', { html: 'Du har bytt ut ditt foto!<h6>Så fort minst fem personer har röstat på ditt nya foto är den med och tävlar.</h6>', type: 'win' });
          }

          __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('photos/' + context.state.atSpot[0] + '/' + photoId).set({
            user: context.state.user.uid,
            username: context.state.user.displayName,
            filename: payLoad.fileName,
            id: photoId,
            url: downloadUrl,
            thumburl: thumbUrl,
            spot: context.state.atSpot[0],
            time: { '.sv': 'timestamp' }
          });
          __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('users/' + context.state.user.uid + '/photos/' + photoId).set({
            filename: payLoad.fileName,
            url: downloadUrl,
            id: photoId,
            thumburl: thumbUrl,
            spot: context.state.atSpot[0],
            user: context.state.user.uid,
            username: context.state.user.displayName
          });
          __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('votes/' + photoId + '/' + context.state.user.uid).set({
            like: 1,
            time: { '.sv': 'timestamp' },
            spot: context.state.atSpot[0]
          });
          __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('votes/' + photoId + '/spot').set(context.state.atSpot[0]);

          context.commit('addAtSpotPhotos', {
            user: context.state.user.uid,
            username: context.state.user.displayName,
            filename: payLoad.fileName,
            url: downloadUrl,
            id: photoId,
            thumburl: thumbUrl,
            time: { '.sv': 'timestamp' }
          });

          context.dispatch('addNotice', {
            text: 'Du laddade upp ett foto till ' + context.state.atSpot[0],
            user: context.state.user.uid,
            type: 'win'
          });
          window.setTimeout(function () {
            context.state.showingPhotoUpload = false;
          }, 1000);
        });
      });
    },
    startGettingNotices: function startGettingNotices(context) {
      var notices = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('notices/' + context.state.user.uid).orderByChild('time').limitToLast(10);
      notices.on('value', function (snapshot) {
        var noticeArray = [];
        snapshot.forEach(function (childSnapshot) {
          var val = childSnapshot.val();
          noticeArray.push(val);
        });
        context.commit('updateNotices', noticeArray);
      });
    },
    fetchUserVisitedSpots: function fetchUserVisitedSpots(context) {
      var ref = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('visitedspots/' + context.state.user.uid);
      ref.on('value', function (snapshot) {
        var visitedspots = [];
        snapshot.forEach(function (childSnapshot) {
          var val = childSnapshot.val();
          visitedspots.push(val);
        });
        context.commit('updateUserVisitedSpots', visitedspots);
      });
    },
    fetchAllSpotsForUser: function fetchAllSpotsForUser(context) {
      var ref = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('spots');
      ref.once('value', function (snapshot) {
        var visitedspots = [];
        snapshot.forEach(function (childsnap) {
          childsnap.forEach(function (spot) {
            visitedspots.push(spot.val());
          });
        });
        context.commit('updateUserVisitedSpots', visitedspots);
      });
      console.log('Laddar in alla spots till användaren');
    },
    addUserVisitedSpot: function addUserVisitedSpot(context, payLoad) {
      if (context.state.user.uid === null) {
        return;
      }
      var visitedspots = context.state.userVisitedSpots.slice();
      for (var i = 0; i < visitedspots.length; i++) {
        if (visitedspots[i].name === payLoad.spot) {
          return;
        }
      }

      context.commit('interupt', { html: 'Du har hittat en ny fotoplats!<h6>Utforska, var kreativ och ta ett foto inom vid denna plats för att vara med och tävla och få möjligheten att tjäna fler poäng. Se andras bilder för inspiration!</h6><h5>+10 poäng</h5>', type: 'win' });
      var ref = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('spots/' + payLoad.areaKey + '/' + payLoad.spot);
      ref.once('value').then(function (snapshot) {
        var toSet = snapshot.val();
        __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('visitedspots/' + context.state.user.uid + '/' + payLoad.spot).set(toSet);
      });
    },
    fetchUserPhotosAndScore: function fetchUserPhotosAndScore(context) {
      var ref = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('users/' + context.state.user.uid + '/photos/');
      ref.on('value', function (snapshot) {
        var photoArray = [];
        var score = 0;
        snapshot.forEach(function (childSnapshot) {
          var val = childSnapshot.val();
          photoArray.push(val);
          if (val.score) {
            score = score + 20 + val.score;
          } else {
            score = score + 20;
          }
        });
        context.commit('setUserScore', score);
        context.commit('setUserPhotos', photoArray);
      });
    },
    fetchHighscore: function fetchHighscore(context) {
      var ref = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('highscore');
      ref.on('value', function (snapshot) {
        var highscore = [];
        snapshot.forEach(function (childSnapshot) {
          var val = childSnapshot.val();
          highscore.push({
            user: childSnapshot.key,
            score: val.score,
            username: val.name
          });
        });
        context.commit('updateHighscore', highscore);
      });
    },
    addNotice: function addNotice(context, payLoad) {
      var notice = {
        user: payLoad.user,
        text: payLoad.text,
        type: payLoad.type,
        read: true,
        time: { '.sv': 'timestamp' }
      };
      var newNotice = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('notices/' + payLoad.user).push();
      newNotice.set(notice);
    },
    fetchWinner: function fetchWinner(context, payLoad) {
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('winner/' + context.state.atSpot[0]).once('value').then(function (snapshot) {
        var winner = null;
        winner = snapshot.val();
        if (winner === null) {} else {
          context.commit('setAtSpotWinner', winner);
        }
      });
    },
    castVoteFor: function castVoteFor(context, payLoad) {
      var voteObj = {
        user: context.state.user.uid,
        username: context.state.user.displayName,
        contestant: payLoad.contestant,
        winner: payLoad.winner,
        time: { '.sv': 'timestamp' }
      };

      if ('votes' in payLoad.battle && 'against' in payLoad.battle.votes && payLoad.battle.votes.against.length > 1) {
        console.log('we have a winner!!!!');
      }

      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('waiting/' + payLoad.contestant + '/votes/for/' + context.state.user.uid).set(voteObj);
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('waiting/' + payLoad.contestant + '/winner').set(payLoad.winner);
      context.dispatch('addNotice', {
        text: 'Someone voted for your photo at ' + payLoad.battle.spot,
        user: payLoad.battle.user,
        type: 'challange'
      });
    },
    castVoteAgainst: function castVoteAgainst(context, payLoad) {
      var voteObj = {
        user: context.state.user.uid,
        username: context.state.user.displayName,
        contestant: payLoad.contestant,
        winner: payLoad.winner,
        time: { '.sv': 'timestamp' }
      };

      if ('votes' in payLoad.battle && 'against' in payLoad.battle.votes && payLoad.battle.votes.against.length > 1) {
        console.log('we have a winner!');
      }

      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('waiting/' + payLoad.contestant + '/votes/against/' + context.state.user.uid).set(voteObj);
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('waiting/' + payLoad.contestant + '/winner').set(payLoad.winner);
      context.dispatch('addNotice', {
        text: 'Someone voted against your photo at ' + payLoad.battle.spot,
        user: payLoad.battle.user,
        type: 'challange'
      });
    },
    fetchBattleWinner: function fetchBattleWinner(context, payLoad) {
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('winners/' + payLoad.spot).orderByChild('time').limitToLast(1).once('value').then(function (snapshot) {
        var winner = null;
        snapshot.forEach(function (childSnapshot) {
          winner = childSnapshot.val();
        });
        if (winner === null) {
          console.log('no winner at spot to battle');
        } else {
          context.commit('setBattleWinner', winner);
        }
      });
    },
    makeWinner: function makeWinner(context, payLoad) {
      console.log('Making a winner', payLoad.contestant);
      var contestant = payLoad.contestant;
      var photoObj = {
        user: contestant.user,
        username: contestant.username,
        firstAtSpot: true,
        url: contestant.url,
        thumburl: contestant.thumburl,
        filename: contestant.filename,
        time: { '.sv': 'timestamp' }
      };
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('winners/' + contestant.spot + '/' + contestant.filename).set(photoObj);
      context.commit('setAtSpotWinner', photoObj);
    },
    fetchAreasFromApi: function fetchAreasFromApi(context) {
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('areas').once('value').then(function (snapshot) {
        snapshot.forEach(function (childSnapshot) {
          var val = childSnapshot.val();

          context.state.areas.push({
            key: childSnapshot.key,
            name: val.name,
            coordinates: val.coordinates
          });
        });
      });
    },
    populateAreas: function populateAreas(context, payload) {},
    populateAreasFromJson: function populateAreasFromJson(context, payLoad) {
      console.log(__WEBPACK_IMPORTED_MODULE_4__json_new_areas_json___default.a.features);
      __WEBPACK_IMPORTED_MODULE_4__json_new_areas_json___default.a.features.forEach(function (yta) {
        var temp = yta.geometry.coordinates[0].map(function (a, index) {
          return { lng: a[0], lat: a[1] };
        });
        __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('areas/' + yta.properties.key).set({
          name: yta.properties.name,
          coordinates: temp
        });
      });
    },
    populateSpots: function populateSpots() {
      __WEBPACK_IMPORTED_MODULE_3__json_spots_update_json___default.a.forEach(function (area) {
        area.spots.forEach(function (spot) {
          __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('spots/' + area.key + '/' + spot.name).set({
            'name': spot.name,
            'coordinates': {
              'lat': spot.lat,
              'lng': spot.lng
            }
          });
        });
        console.log(area);
      });
    },
    fetchSpots: function fetchSpots(context, payload) {
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('spots/' + payload.areaKey).once('value').then(function (snapshot) {
        context.state.spots = [];
        snapshot.forEach(function (childSnapshot) {
          var val = childSnapshot.val();

          __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('winner/' + val.name).once('value').then(function (snapshotWinner) {
            var winner = null;
            winner = snapshotWinner.val();
            context.state.spots.push({
              key: childSnapshot.key,
              name: val.name,
              coordinates: val.coordinates,
              winner: winner
            });
          });
        });
      });
    },
    startVoting: function startVoting(context) {
      if (context.state.user === null) {} else {
        var voteOnMe = __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('votes').orderByChild(context.state.user.uid).equalTo(null).limitToFirst(1);
        voteOnMe.on('value', function (snapshot) {
          var photoInfo = null;
          var photoId = null;
          if (snapshot.val() === null) {
            context.commit('updateVoteOnPhoto', 0);
          } else {
            snapshot.forEach(function (snapshotObj) {
              photoInfo = snapshotObj.val();

              photoId = snapshotObj.key;
              __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('photos/' + photoInfo.spot + '/' + photoId).once('value').then(function (snapshotToVoteOn) {
                var photoToVoteOn = snapshotToVoteOn.val();
                context.commit('updateVoteOnPhoto', photoToVoteOn);
              });
            });
          }
        });
      }
    },
    vote: function vote(context, payLoad) {
      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('votes/' + payLoad.photoId + '/' + context.state.user.uid).set({
        like: payLoad.score,
        spot: payLoad.spot,
        time: { '.sv': 'timestamp' }
      });
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(27),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolocator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_geolocator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_geolocator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_geolib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_geolib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__classes_spot3d__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__classes_objects3d__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_objects_json__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__json_objects_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__json_objects_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__classes_makeSpot__ = __webpack_require__(23);









var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);

    this.things = [];
    this.objects = [];
    this.winners = [];
    this.winar = [];
    this.winnerPos = {};
    this.winarTitle = {};
    this.winnerGroup = new window.THREE.Group();
    this.thingGroup = new window.THREE.Group();
    this.watchLocation = null;
    this.spot3d = new __WEBPACK_IMPORTED_MODULE_4__classes_spot3d__["a" /* default */]();
    this.objects3d = new __WEBPACK_IMPORTED_MODULE_5__classes_objects3d__["a" /* default */]();
    this.makeSpot = new __WEBPACK_IMPORTED_MODULE_7__classes_makeSpot__["a" /* default */]();

    this.locationOptions = {
      enableHighAccuracy: false,
      timeout: 5000,
      maximumWait: 10000,
      maximumAge: 0,
      desiredAccuracy: 1,
      fallbackToIP: true,
      addressLookup: false,
      timezone: false
    };
    __WEBPACK_IMPORTED_MODULE_2_geolocator___default.a.config({
      language: 'en',
      google: {
        version: '3',
        key: 'AIzaSyBP498t5dAbPMm_x9CsRzGxSK_wrtZtOnc'
      }
    });
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'test',
    value: function test() {
      console.log('testar att importera en fil');
    }
  }, {
    key: 'getCurrentLocation',
    value: function getCurrentLocation(callback) {
      __WEBPACK_IMPORTED_MODULE_2_geolocator___default.a.locate(this.locationOptions, function (err, location) {
        if (err) return console.log(err);
        callback(location.coords);
      });
    }
  }, {
    key: 'watchCurrentLocation',
    value: function watchCurrentLocation(callback) {
      var options = { enableHighAccuracy: true, timeout: 6000, maximumAge: 0 };
      this.watchLocation = __WEBPACK_IMPORTED_MODULE_2_geolocator___default.a.watch(options, function (err, location) {
        if (err) return console.log(err);
      });
    }
  }, {
    key: 'renderSceneObjects',
    value: function renderSceneObjects(areakey, coordOrig, scene, callback) {
      var colors = {
        blue: 0x1F5585,
        purple: 0x3B4D78,
        pink: 0x844660,
        yellow: 0xFFC757,
        white: 0xF5F5F5
      };
      var self = this;
      for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_6__json_objects_json___default.a.length; i++) {
        var obj = __WEBPACK_IMPORTED_MODULE_6__json_objects_json___default.a[i];
        var mesh = null;
        switch (obj.type) {
          case 'tree':
            mesh = this.objects3d[obj.type]();
            break;
          case 'mountain':
            if (typeof obj.options.mega !== 'undefined') {
              mesh = this.objects3d[obj.type](colors[obj.options.color], true);
            } else {
              mesh = this.objects3d[obj.type](colors[obj.options.color]);
            }
            break;
          case 'sphere':
            mesh = this.objects3d[obj.type](colors[obj.options.color], obj.options.size);
            break;
          default:
            mesh = this.objects3d[obj.type]();
        }
        var itemCoord = {
          latitude: obj.coordinates[1],
          longitude: obj.coordinates[0]
        };
        var xyz = null;
        if (obj.type === 'tree') {
          if (obj.area === areakey) {
            xyz = this.getXY(itemCoord, coordOrig);
            mesh.name = obj.name;
            mesh.position.x = xyz.x;
            mesh.position.z = xyz.z;
            mesh.position.y = obj.y;
            self.objects.push({
              name: obj.name,
              mesh: mesh,
              xyz: xyz,
              coordinates: obj.coordinates
            });
            mesh.lookAt({ x: 0, z: 0, y: 2 });
            scene.add(mesh);
          }
        } else {
          xyz = this.getXY(itemCoord, coordOrig);
          mesh.name = obj.name;
          mesh.position.x = xyz.x;
          mesh.position.z = xyz.z;
          mesh.position.y = obj.y;
          self.objects.push({
            name: obj.name,
            mesh: mesh,
            xyz: xyz,
            coordinates: obj.coordinates
          });
          scene.add(mesh);
        }
      }


      return this.objects;
    }
  }, {
    key: 'renderThings',
    value: function renderThings(areakey, coordOrig, items, scene, objects, winners, callback) {
      var _this = this;

      if (objects === true) {
        this.renderSceneObjects(areakey, coordOrig, scene);
      }

      var exCoords = {
        latitude: 59.331480,
        longitude: 18.071500
      };

      this.winnerPos.xyz = this.getXY(exCoords, coordOrig);

      var _loop = function _loop() {
        var thumb = winners[u].thumburl;

        var self = _this;
        var meshBasicObjectWinner = { color: 0xffffff, side: window.THREE.DoubleSide };

        textureClosure2 = function textureClosure2(u, self) {
          var textureLoader = new window.THREE.TextureLoader();
          textureLoader.crossOrigin = '';
          textureLoader.load(thumb, function (texture) {
            texture.repeat.set(1, 1);
            texture.needsUpdate = true;
            meshBasicObjectWinner = { map: texture, needsUpdate: true, side: window.THREE.DoubleSide };
            self.winar[u].material = new window.THREE.MeshBasicMaterial(meshBasicObjectWinner);
            self.winar[u].material.needsUpdate = true;
            self.winar[u].obj.material = self.winar[u].material;
          }, function (progress) {}, function (error) {
            console.log(error);
          });
        };

        textureClosure2(u, self);
        var materials = new window.THREE.MeshBasicMaterial(meshBasicObjectWinner);
        var geometrys = new window.THREE.PlaneGeometry(10, 10, 1);
        geometrys.dynamic = true;
        geometrys.verticesNeedUpdate = true;
        _this.winar.push({
          geometry: geometrys,
          material: materials,

          writable: true,
          name: winners[u].id
        });
        _this.winar[u].obj = new window.THREE.Mesh(_this.winar[u].geometry, _this.winar[u].material);
        _this.winar[u].obj.position.z = -4 * u + 50;
        _this.winar[u].obj.position.x = -4 * u + Math.random() * 100;
        _this.winar[u].obj.position.y = 40;
        _this.winar[u].obj.name = winners[u].id;
        _this.winnerGroup.add(_this.winar[u].obj);
      };

      for (var u = 0; u < winners.length; u++) {
        var textureClosure2;

        _loop();
      }
      this.winarTitle = this.spot3d.addSoloTitle('Exhibition Stockholm');
      this.winnerGroup.add(this.winarTitle);
      this.winnerGroup.position.z = this.winnerPos.xyz.z;
      this.winnerGroup.position.x = this.winnerPos.xyz.x;
      this.winnerGroup.position.y = 0;
      this.winnerGroup.lookAt({ x: 0, z: 0, y: 2 });
      scene.add(this.winnerGroup);

      var _loop2 = function _loop2() {
        meshBasicObject = { color: 0xffffff, side: window.THREE.DoubleSide };

        var thumb = 'https://firebasestorage.googleapis.com/v0/b/takeitmakeit-b7ef1.appspot.com/o/assets%2Femptyspot.png?alt=media&token=b9b29c6c-57ef-4d65-a72a-0e39271ea036';
        if ('winner' in items[i] && items[i].winner !== null) {
          thumb = items[i].winner.thumburl;
        }
        self = _this;

        textureClosure = function textureClosure(i, self) {
          var textureLoader = new window.THREE.TextureLoader();
          textureLoader.crossOrigin = '';
          textureLoader.load(thumb, function (texture) {
            texture.repeat.set(1, 1);
            meshBasicObject = { map: texture, needsUpdate: true, side: window.THREE.DoubleSide };
            self.things[i].material = new window.THREE.MeshBasicMaterial(meshBasicObject);
            self.things[i].material.needsUpdate = true;
            self.things[i].arobj.material = self.things[i].material;
          }, function (progress) {}, function (error) {
            console.log(error);
          });
        };

        textureClosure(i, self);
        var material = new window.THREE.MeshBasicMaterial(meshBasicObject);

        var geometry = new window.THREE.PlaneGeometry(10, 10, 1);
        geometry.dynamic = true;
        geometry.verticesNeedUpdate = true;
        material.needsUpdate = true;
        _this.things.push({
          geometry: geometry,
          material: material,

          writable: true,
          name: items[i].name
        });
        l = _this.things.length - 1;


        _this.things[l].border = new window.THREE.Group();

        _this.things[l].border.add(_this.makeSpot.makeBorder());
        _this.things[l].border.add(_this.spot3d.addConeArrow());
        _this.things[l].border.add(_this.spot3d.addSoloTitle(_this.things[l].name));

        _this.things[l].arobj = new window.THREE.Mesh(_this.things[l].geometry, _this.things[l].material);

        if (items[i].coordinates) {
          var itemCoord = {
            latitude: items[i].coordinates.lat,
            longitude: items[i].coordinates.lng
          };
          _this.things[l].xyz = _this.getXY(itemCoord, coordOrig);
        } else {
          _this.things[l].xyz = { x: 0, z: 0 };
        }

        _this.things[l].arobj.position.z = _this.things[l].xyz.z;
        _this.things[l].arobj.position.x = _this.things[l].xyz.x;
        _this.things[l].arobj.position.y = 6;
        _this.things[l].border.position.z = _this.things[l].xyz.z;
        _this.things[l].border.position.x = _this.things[l].xyz.x;
        _this.things[l].border.position.y = 6;
        _this.things[l].arobj.name = _this.things[l].name;
        _this.things[l].arobj.lookAt({ x: 0, z: 0, y: 8 });
        _this.things[l].border.lookAt({ x: 0, z: 0, y: 8 });
        _this.things[l].waves = [];
        scene.add(_this.things[l].arobj);
        scene.add(_this.things[l].border);
      };

      for (var i = 0; i < items.length; i++) {
        var meshBasicObject;
        var self;
        var textureClosure;
        var l;

        _loop2();
      }
      typeof callback === 'function' && callback();
    }
  }, {
    key: 'clearThings',
    value: function clearThings(scene, camera) {
      for (var i = 0; i < this.things.length; i++) {
        for (var j = 0; j < this.things[j].waves.length; j++) {
          scene.remove(this.things[i].waves[j].mesh);
          this.things[i].waves[j].mesh.geometry.dispose();
          this.things[i].waves[j].mesh.material.dispose();
          this.things[i].waves[j] = null;
        }

        scene.remove(this.things[i].arobj.mesh);
        scene.remove(this.things[i].border);
        this.things[i].arobj.mesh.geometry.dispose();
        this.things[i].arobj.mesh.geometry.dispose();
        this.things[i].arobj = null;
        this.things[i].border.mesh.geometry.dispose();
        this.things[i].border.mesh.geometry.dispose();
        this.things[i].border = null;
      }
      this.things = [];
    }
  }, {
    key: 'locationUpdateThings',
    value: function locationUpdateThings(items, coords) {
      var exCoords = {
        latitude: 59.331480,
        longitude: 18.071500
      };

      this.winnerPos.xyz = this.getXY(exCoords, coords);
      console.log('new winnerpos', this.winnerPos.xyz);
      for (var i = 0; i < items.length; i++) {
        if (items[i].coordinates) {
          var itemCoord = {
            latitude: items[i].coordinates.lat,
            longitude: items[i].coordinates.lng
          };
          var newCoords = this.getXY(itemCoord, coords);

          this.things[i].xyz = newCoords;
          this.things[i].target_xyz = null;
        } else {
          this.things[i].xyz = { x: 60, z: 60 };
        }
      }
    }
  }, {
    key: 'clickHandler',
    value: function clickHandler(event, scene, camera, raycaster, mouse, renderer, callback) {
      event.preventDefault();
      mouse.x = event.clientX / renderer.domElement.clientWidth * 2 - 1;
      mouse.y = -1 * (event.clientY / renderer.domElement.clientHeight) * 2 + 1;
      raycaster.setFromCamera(mouse, camera);
      var objects = this.winar.map(function (a) {
        return a.obj;
      });

      var intersects = raycaster.intersectObjects(objects);
      typeof callback === 'function' && callback(intersects);
    }
  }, {
    key: 'getUpdatedPosition',
    value: function getUpdatedPosition(oldCoords, newCoords) {
      var maxDelta = function maxDelta(dist) {
        return Math.abs(dist) / 70;
      };
      var currentDist = Math.sqrt(Math.pow(oldCoords.x, 2) + Math.pow(oldCoords.z, 2));
      if (currentDist >= 60) {
        return newCoords;
      }
      var newC = {
        x: newCoords.x,
        z: newCoords.z
      };
      if (typeof oldCoords.x !== 'undefined' && typeof newC.x !== 'undefined') {
        var delta = {
          x: newC.x - oldCoords.x,
          z: newC.z - oldCoords.z
        };
        var maxX = maxDelta(newC.x);
        if (Math.abs(delta.x) > maxX && delta.x !== 0) {
          newC.x = oldCoords.x + maxX * (delta.x / Math.abs(delta.x));
        }
        var maxZ = maxDelta(newC.z);
        if (Math.abs(delta.z) > maxZ && delta.z !== 0) {
          newC.z = oldCoords.z + maxZ * (delta.z / Math.abs(delta.z));
        }
        return newC;
      } else {
        return newCoords;
      }
    }
  }, {
    key: 'updateThings',
    value: function updateThings(scene, camera) {
      var shortestDistance = null;

      if (this.winnerPos.xyz) {
        var winnerNew = this.getUpdatedPosition(this.winnerGroup.position, this.winnerPos.xyz);
        this.winnerGroup.position.z = winnerNew.z;
        this.winnerGroup.position.x = winnerNew.x;
        this.winnerGroup.lookAt({ x: 0, z: 0, y: 2 });
        this.winnerGroup.updateMatrix();

        shortestDistance = Math.sqrt(Math.pow(winnerNew.z, 2) + Math.pow(winnerNew.x, 2));
      }

      for (var i = 0; i < this.things.length; i++) {
        var newCoords = this.getUpdatedPosition(this.things[i].arobj.position, this.things[i].xyz);

        this.things[i].arobj.position.z = newCoords.z;
        this.things[i].arobj.position.x = newCoords.x;
        this.things[i].border.position.z = newCoords.z;
        this.things[i].border.position.x = newCoords.x;
        this.things[i].arobj.lookAt({ x: 0, z: 0, y: 8 });
        this.things[i].border.lookAt({ x: 0, z: 0, y: 8 });

        var closestDistance = Math.sqrt(Math.pow(newCoords.x, 2) + Math.pow(newCoords.z, 2));
        if (shortestDistance === null) {
          shortestDistance = closestDistance;
        }
        if (shortestDistance > closestDistance) {
          shortestDistance = closestDistance;
        }
      }
      return { thing: 'kungsan', dist: shortestDistance };
    }
  }, {
    key: 'makeNewWaveLine',
    value: function makeNewWaveLine(rad) {
      var segmentCount = 60;
      var radius = rad;
      var geometry = new window.THREE.Geometry();

      for (var i = 0; i <= segmentCount; i++) {
        var theta = i / segmentCount * Math.PI * 2;
        geometry.vertices.push(new window.THREE.Vector3(Math.cos(theta) * radius, Math.sin(theta) * radius, 0));
      }
      geometry.vertices.push(geometry.vertices[0].clone());
      var line = new window.MeshLine();
      line.setGeometry(geometry);
      return line;
    }
  }, {
    key: 'makeNewWave',
    value: function makeNewWave(rad, camera) {
      var line = this.makeNewWaveLine(rad);
      var material = new window.MeshLineMaterial({
        lineWidth: 0.1,
        color: new window.THREE.Color(0xFFFFFF),
        side: window.THREE.FrontSide,
        near: camera.near,
        far: camera.far
      });

      var mesh = new window.THREE.Mesh(line.geometry, material);
      mesh.rotation.set(-90 * (3.14 / 180), 0, 0, 'XYZ');
      mesh.position.y = -6;
      mesh.geometry.writable = true;
      mesh.position.writable = true;
      return mesh;
    }
  }, {
    key: 'getXY',
    value: function getXY(coord, coordOrig) {
      var d = __WEBPACK_IMPORTED_MODULE_2_geolocator___default.a.calcDistance({
        from: coordOrig,
        to: coord,
        formula: __WEBPACK_IMPORTED_MODULE_2_geolocator___default.a.DistanceFormula.PYTHAGOREAN,
        unitSystem: __WEBPACK_IMPORTED_MODULE_2_geolocator___default.a.UnitSystem.METRIC
      }) * 1000;
      var b = __WEBPACK_IMPORTED_MODULE_3_geolib___default.a.getBearing(coordOrig, coord);
      var z = -1 * (Math.cos(b * Math.PI / 180) * d);
      var x = 1 * (Math.sin(b * Math.PI / 180) * d);
      return {
        x: x,
        z: z
      };
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'makeSpotPic',
    value: function makeSpotPic(thumb, thing) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 1024;
      canvas.height = 1024;
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      var picImage = new Image();
      picImage.src = thumb;
      picImage.onload = function () {
        context.drawImage(picImage, 1024, 1024);
        var textureUp = new window.THREE.Texture(canvas);
        textureUp.needsUpdate = true;
        thing.arobj.material = new window.THREE.MeshBasicMaterial({ map: textureUp });
      };
      var texture = new window.THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new window.THREE.MeshBasicMaterial({ map: texture });
      var mesh = new window.THREE.Mesh(new window.THREE.PlaneGeometry(10, 10, 1), material);
      mesh.dynamic = true;
      return mesh;
    }
  }, {
    key: 'makeBorder',
    value: function makeBorder() {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 1024;
      canvas.height = 1024;
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      var texture = new window.THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new window.THREE.MeshBasicMaterial({ map: texture });
      var mesh = new window.THREE.Mesh(new window.THREE.PlaneGeometry(13, 13, 1), material);
      mesh.dynamic = true;
      mesh.position.z = -1;
      return mesh;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'mountain',
    value: function mountain(colorHex, mega) {
      if (typeof window.mountainGeometry === 'undefined') {
        window.mountainGeometry = new window.THREE.ConeGeometry(820, 1400, 32);
        window.megaMountainGeometry = new window.THREE.ConeGeometry(4820, 7400, 32);
      }

      var material = new window.THREE.MeshPhongMaterial({
        color: colorHex,
        emissive: colorHex,
        emissiveIntensity: 0.2
      });
      var cone = null;
      if (typeof mega !== 'undefined') {
        cone = new window.THREE.Mesh(window.megaMountainGeometry, material);
      } else {
        cone = new window.THREE.Mesh(window.mountainGeometry, material);
      }
      return cone;
    }
  }, {
    key: 'cloud',
    value: function cloud() {
      var mesh = new window.THREE.Object3D();
      if (typeof window.cloudgeom === 'undefined') {
        window.cloudgeom = new window.THREE.SphereGeometry(30, 16, 16);
      }
      if (typeof window.cloudmat === 'undefined') {
        window.cloudmat = new window.THREE.MeshPhongMaterial({
          color: 0xDDDDDD,
          emissive: 0xDDDDDD,
          emissiveIntensity: 0
        });
      }

      var nBlocs = 3 + Math.floor(Math.random() * 1);
      for (var i = 0; i < nBlocs; i++) {
        var m = new window.THREE.Mesh(window.cloudgeom, window.cloudmat);
        var s = 0.5 + Math.random() * 0.8;
        m.position.x = i * 30;
        m.position.y = 10 * s * 2;
        m.position.z = Math.random() * 10;
        m.rotation.z = Math.random() * Math.PI * 2;
        m.scale.set(s, s, s);
        m.castShadow = true;
        m.receiveShadow = true;
        mesh.add(m);
      }
      return mesh;
    }
  }, {
    key: 'sphere',
    value: function sphere(colorHex, size) {
      var mesh = new window.THREE.Object3D();
      var geom = new window.THREE.SphereGeometry(size, 16, 16);
      var mat = new window.THREE.MeshPhongMaterial({
        color: colorHex,
        emissive: colorHex,
        emissiveIntensity: 0
      });
      var m = new window.THREE.Mesh(geom, mat);
      m.castShadow = true;
      m.receiveShadow = true;
      mesh.add(m);
      return mesh;
    }
  }, {
    key: 'fotoTip',
    value: function fotoTip() {
      var tips = ['När du fotar i RAW-format sparas all så \n kallad rådata i bilden. En stor fördel med att spara datan är att du kan redigera bilden utan att den förlorar i kvalitet.'];
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 1024;
      canvas.height = 256;
      canvas.style.backgroundColor = 'transparent !important';
      canvas.style.letterSpacing = '1px';
      context.textAlign = 'center';
      context.font = '164px jaf-domus';
      context.fillStyle = 'rgba(0,0,0,1)';
      context.fillText(tips[0], canvas.width / 2, 120);
      var texture = new window.THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new window.THREE.MeshBasicMaterial({ map: texture, transparent: true, alphaTest: 0.1 });

      var mesh = new window.THREE.Mesh(new window.THREE.PlaneGeometry(500, 200, 1, 1), material);
      mesh.dynamic = true;
      return mesh;
    }
  }, {
    key: 'tree',
    value: function tree() {
      var mesh = new window.THREE.Object3D();
      var stem = new window.THREE.CylinderGeometry(0.2, 0.2, 4, 16);
      var wood = new window.THREE.MeshPhongMaterial({
        color: 0x84695D,
        emissive: 0x84695D,
        emissiveIntensity: 0
      });
      var mStem = new window.THREE.Mesh(stem, wood);
      var mat = new window.THREE.MeshPhongMaterial({
        color: 0x558E70,
        emissive: 0x558E70,
        emissiveIntensity: 0
      });
      var green1 = new window.THREE.SphereGeometry(1, 16, 16);
      var green2 = new window.THREE.SphereGeometry(0.55, 16, 16);
      var mGreen1 = new window.THREE.Mesh(green1, mat);
      mGreen1.position.x = -0.95;
      mGreen1.position.y = 0.96;
      var mGreen2 = new window.THREE.Mesh(green2, mat);
      mGreen2.position.x = 0.3;
      mGreen2.position.y = 1.8;
      mesh.add(mGreen1);
      mesh.add(mGreen2);
      mesh.add(mStem);
      return mesh;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var _class = function () {
  function _class() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, _class);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(_class, [{
    key: 'addExhibitTitle',
    value: function addExhibitTitle(spotName, winnerName) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 6024;
      canvas.height = 256;
      canvas.style.backgroundColor = 'transparent !important';

      canvas.style.letterSpacing = '1px';
      context.textAlign = 'center';
      context.font = '140px jaf-domus';
      context.fillStyle = 'rgba(0,0,0,1)';
      context.fillText(spotName, canvas.width / 2, 120);

      canvas.style.letterSpacing = '3px';
      context.textAlign = 'center';
      context.font = '52px jaf-domus';
      context.fillStyle = 'rgba(0,0,0,1)';
      context.fillText('T I T T A  M O T  H I M M E L E N !', canvas.width / 2, 135);

      var texture = new window.THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new window.THREE.MeshBasicMaterial({ map: texture, transparent: true, alphaTest: 0.1 });

      var mesh = new window.THREE.Mesh(new window.THREE.PlaneGeometry(40, 4, 1), material);
      mesh.dynamic = true;
      return mesh;
    }
  }, {
    key: 'addSoloTitle',
    value: function addSoloTitle(spotName) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 1024;
      canvas.height = 256;
      canvas.style.backgroundColor = 'transparent !important';
      canvas.style.backgroundColor = 'rgba(255,255,255,1)';
      context.textAlign = 'center';
      context.font = '120px jaf-domus';
      context.fillStyle = 'rgba(255,255,255,1)';
      context.fillText(spotName, canvas.width / 2, canvas.height / 2);
      var texture = new window.THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new window.THREE.MeshBasicMaterial({ map: texture, transparent: true, alphaTest: 0.1 });
      var mesh = new window.THREE.Mesh(new window.THREE.PlaneGeometry(60.2, 15.64, 1), material);
      mesh.position.y = 10;
      mesh.position.z = 0;
      mesh.dynamic = true;
      return mesh;
    }
  }, {
    key: 'addChallengeButton',
    value: function addChallengeButton(name) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 1024;
      canvas.height = 128;
      context.fillStyle = '#2f4efd';
      context.fillRect(0, 0, canvas.width, canvas.height);
      canvas.style.letterSpacing = '1px';
      context.textAlign = 'center';
      context.font = '56px jaf-domus';
      context.fillStyle = 'rgba(255,255,255,1)';
      context.fillText('Challenge photo', canvas.width / 2, 86);

      var texture = new window.THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new window.THREE.MeshBasicMaterial({ map: texture });
      material.transparent = true;
      texture.repeat.set(1, 1);
      var mesh = new window.THREE.Mesh(new window.THREE.PlaneGeometry(8.5, 1.1, 1), material);
      mesh.position.y = -8.1;
      mesh.name = name + '_challenge';
      return mesh;
    }
  }, {
    key: 'addViewButton',
    value: function addViewButton(name) {
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d');
      canvas.width = 1024;
      canvas.height = 128;
      context.fillStyle = '#fff';
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.fillStyle = '#fff';
      context.fillRect(4, 4, canvas.width - 8, canvas.height - 8);
      canvas.style.letterSpacing = '1px';
      context.textAlign = 'center';
      context.font = '56px jaf-domus';
      context.fillStyle = 'rgba(0,0,0,1)';
      context.fillText('KLICKA  PÅ FOTO', canvas.width / 2, 86);

      var texture = new window.THREE.Texture(canvas);
      texture.needsUpdate = true;
      var material = new window.THREE.MeshBasicMaterial({ map: texture });
      material.transparent = true;
      texture.repeat.set(1, 1);
      var mesh = new window.THREE.Mesh(new window.THREE.PlaneGeometry(8.3, 1.1, 1), material);
      mesh.position.y = -9.4;
      mesh.name = name + '_view';
      return mesh;
    }
  }, {
    key: 'addWhiteBack',
    value: function addWhiteBack() {
      var groundGeo = new window.THREE.PlaneBufferGeometry(10, 14);
      var groundMat = new window.THREE.MeshBasicMaterial({ color: 0xFFFFFF });

      var ground = new window.THREE.Mesh(groundGeo, groundMat);
      ground.position.y = -4.3;
      ground.position.z = -0.1;
      ground.castShadow = false;
      return ground;
    }
  }, {
    key: 'addSpotSpotLight',
    value: function addSpotSpotLight() {
      var spotlight = new window.THREE.SpotLight(0xffffff, 1.5, 60, 1.05, 1.05, 2);
      spotlight.castShadow = true;
      spotlight.position.set(0, 10, 0);
      spotlight.target.position.set(0, 0, 0);
      spotlight.castShadow = true;
      return spotlight;
    }
  }, {
    key: 'addConeArrow',
    value: function addConeArrow() {
      var arrow = new window.THREE.CylinderGeometry(25, 0, 90, 16);
      var mat = new window.THREE.MeshPhongMaterial({
        color: 0xD1AD68,
        emissive: 0xD1AD68,
        emissiveIntensity: 0
      });
      var m = new window.THREE.Mesh(arrow, mat);
      m.position.y = 65;
      return m;
    }
  }]);

  return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(20);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

window.app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  beforeCreate: function beforeCreate() {},

  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Location__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Location___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Location__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Auth__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Auth___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Auth__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_spot__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_spot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_spot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PhotoUpload__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_PhotoUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_PhotoUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Interupt__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Interupt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Interupt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_errupt__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_errupt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_errupt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_photo__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_photo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_infoMenu__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_infoMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_infoMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FloatMenu__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FloatMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_FloatMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Textpage__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Textpage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Textpage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Spotdistance__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Spotdistance___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_Spotdistance__);
















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      currentRoute: null
    };
  },

  computed: {
    highscore: function highscore() {
      return this.$store.state.highscore;
    },
    showMenu: function showMenu() {
      return this.$store.state.showMenu;
    },
    user: function user() {
      return this.$store.state.user;
    },
    textPage: function textPage() {
      return this.$store.state.textPageContent;
    },
    interupt: function interupt() {
      return this.$store.state.interupt;
    },
    showingOverlay: function showingOverlay() {
      return this.$store.getters.showingOverlay;
    },
    showingPhotoUpload: function showingPhotoUpload() {
      return this.$store.state.showingPhotoUpload;
    },
    locationError: function locationError() {
      return this.$store.state.locationError;
    },
    singlePhoto: function singlePhoto() {
      return this.$store.state.singlePhoto;
    },
    infoMenu: function infoMenu() {
      return this.$store.state.infoMenu;
    }
  },
  watch: {
    '$route': function $route(val) {
      this.currentRoute = val.name;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchAreasFromApi');
    this.currentRoute = this.$router.currentRoute.name;
  },

  components: { location: __WEBPACK_IMPORTED_MODULE_0__components_Location___default.a, auth: __WEBPACK_IMPORTED_MODULE_1__components_Auth___default.a, spot: __WEBPACK_IMPORTED_MODULE_2__components_spot___default.a, photoUpload: __WEBPACK_IMPORTED_MODULE_3__components_PhotoUpload___default.a, interupt: __WEBPACK_IMPORTED_MODULE_4__components_Interupt___default.a, errupt: __WEBPACK_IMPORTED_MODULE_5__components_errupt___default.a, photo: __WEBPACK_IMPORTED_MODULE_6__components_photo___default.a, infoMenu: __WEBPACK_IMPORTED_MODULE_7__components_infoMenu___default.a, floatMenu: __WEBPACK_IMPORTED_MODULE_8__components_FloatMenu___default.a, textPage: __WEBPACK_IMPORTED_MODULE_9__components_Textpage___default.a, spotdistance: __WEBPACK_IMPORTED_MODULE_10__components_Spotdistance___default.a }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_ArgameEx__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Infobox__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Infobox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Infobox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Db__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_singleFeed__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_singleFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_singleFeed__);






var game = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'arex',
  data: function data() {
    return {
      msg: 'AR',
      app: '',
      closestSpot: null,
      shouldLoad: true,
      currentArea: 'exhibit',
      winnerPhotos: [],
      showingPhotoId: null,
      hasShownWarning: false
    };
  },

  computed: {
    infotext: function infotext() {
      var html = '';
      html = 'Välkommen till utställningen!<h6>Om du är i Kungsträdgården så kan du titta upp mot himmelen och se alla vinnarbilderna från Exhibition Stockholm 2017. Klicka på bilderna för en närmare titt.';
      return html;
    },
    userLocation: function userLocation() {
      return this.$store.state.userLocation;
    },
    spots: function spots() {
      return this.$store.state.spots;
    },
    atSpot: function atSpot() {
      return this.$store.state.atSpot;
    },
    user: function user() {
      return this.$store.state.user;
    }
  },
  methods: {
    close: function close() {
      console.log('should go to start.');
      window.location.href = 'https://game.exhibitionstockholm.se';
    },
    getAllWinners: function getAllWinners(callback) {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('finalwinners').once('value', function (snapshot) {
        snapshot.forEach(function (child) {
          _this.winnerPhotos.push(child.val());
        });
        _this.photosLoaded = true;
        typeof callback === 'function' && callback(_this.winnerPhotos);
      });
    },
    hasGetUserMedia: function hasGetUserMedia() {
      return !!(navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia);
    },
    startCamera: function startCamera() {
      navigator.mediaDevices.enumerateDevices().then(function (devices) {
        var videoDevices = [];
        devices.forEach(function (device) {
          if (device.kind === 'videoinput') {
            videoDevices.push(device.deviceId);
          }
        });
        var choosenId = videoDevices[0];
        if (videoDevices[1]) {
          choosenId = videoDevices[1];
        }
        var constraints = { deviceId: { exact: choosenId }, video: { mandatory: { minWidth: 1920, minHeight: 1080 } } };
        return constraints;
      }).then(function (constraints) {
        var errorCallback = function errorCallback(e) {};
        navigator.getUserMedia({ video: constraints, audio: false }, function (localMediaStream) {
          var video = document.getElementById('camera-video');
          video.src = window.URL.createObjectURL(localMediaStream);
          video.onloadedmetadata = function (e) {};
        }, errorCallback);
      });
    },
    userOS: function userOS() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return true;
      }
      if (/android/i.test(userAgent)) {
        return true;
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return false;
      }
      return false;
    },
    addSpots: function addSpots(spots, game) {
      var self = this;
      var userCurrentLocation = {
        latitude: self.userLocation.lat,
        longitude: self.userLocation.lng
      };
      var areakey = this.currentArea;

      game.renderThings(areakey, userCurrentLocation, spots, window.arEngine.scene, false);
    },
    clickHandler: function clickHandler(event) {
      var self = this;
      game.clickHandler(event, window.arEngine.scene, window.arEngine.camera, window.arEngine.raycaster, window.arEngine.mouse, window.arEngine.renderer, function (object) {
        if (object.length > 0) {
          self.showingPhotoId = object[0].object.name;
        } else {}
      });
    }
  },
  watch: {
    closestSpot: function closestSpot(val) {},
    userLocation: function userLocation(val) {
      if (game) {
        var userCurrentLocation = {
          latitude: val.lat,
          longitude: val.lng
        };

        game.locationUpdateThings([], userCurrentLocation);
      }
    },
    currentArea: function currentArea(val) {
      if (val === null) {}
    }
  },
  beforeMount: function beforeMount() {
    this.shouldLoad = true;
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$store.commit('interupt', this.infotext);
    this.$store.commit('setNeedsReload', true);
    var canShowCamera = this.hasGetUserMedia();
    if (!this.userOS()) {
      canShowCamera = false;
    }
    if (canShowCamera === false) {} else {
      this.startCamera();
    }
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Ar - Utställning');
    }
    this.$store.commit('setWasAtAr', true);
    this.$store.commit('changeShowMenu', true);
    game = new __WEBPACK_IMPORTED_MODULE_0__classes_ArgameEx__["a" /* default */]();
    var userCurrentLocation = {
      latitude: this.userLocation.lat,
      longitude: this.userLocation.lng
    };
    window.arEngine.onMount(canShowCamera);
    var areakey = this.currentArea;
    this.getAllWinners(function (winners) {
      var showObj = !canShowCamera;
      game.renderThings(areakey, userCurrentLocation, _this2.spots, window.arEngine.scene, showObj, winners, function () {});
    });
    window.arEngine.setUpdateEvent(game, function (close) {
      if (close.dist > 1200 && !_this2.hasShownWarning) {
        _this2.hasShownWarning = true;
      }
    });
    window.addEventListener('compassneedcalibration', function () {
      var html = 'Din kompass behöver kalibreras!<h6>Rör din telefon i 8or ett par gånger.</h6>';
      _this2.$store.commit('interupt', html);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!window.arEngine) {
      window.arEngine.destroy();
    }
    this.$store.dispatch('setAtSpot', { spotname: null, distance: 0 });
    this.$store.commit('showingPhotoUpload', false);
  },

  components: { infobox: __WEBPACK_IMPORTED_MODULE_1__components_Infobox___default.a, singleFeed: __WEBPACK_IMPORTED_MODULE_3__components_singleFeed___default.a }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Db_js__ = __webpack_require__(1);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'auth',
  data: function data() {
    return {
      msg: 'test'
    };
  },

  computed: {
    showAuth: function showAuth() {
      return this.$store.state.showAuth;
    },
    user: function user() {
      return this.$store.state.user;
    }
  },
  methods: {},
  watch: {},
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__classes_Db_js__["a" /* default */].auth().onAuthStateChanged(function (user) {
      _this.$store.commit('updateUserCheck', true);
      _this.$store.commit('updateUser', user);
      if (user !== null && 'uid' in user) {
        _this.$store.dispatch('startGettingNotices');

        _this.$store.dispatch('fetchUserPhotosAndScore');

        _this.$store.dispatch('fetchAllSpotsForUser');
        _this.$store.dispatch('fetchHighscore');
      }
    });
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'floatMenu',
  data: function data() {
    return {
      open: false
    };
  },

  computed: {
    user: function user() {
      return this.$store.state.user;
    }
  },
  methods: {
    toggle: function toggle() {
      this.open = !this.open;
    },
    closeMenu: function closeMenu() {
      this.open === true;
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('changeShowMenu', false);
  }
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'infobox',
  data: function data() {
    return {
      isOpen: true
    };
  },

  props: ['text'],
  computed: {},
  methods: {
    toggleBubble: function toggleBubble() {
      this.$store.commit('interupt', this.text);
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'interupt',
  computed: {
    interupt: function interupt() {
      var rupt = this.$store.state.interupt;
      if (typeof rupt === 'string') {
        return rupt;
      } else {
        return rupt.html;
      }
    },
    type: function type() {
      var rupt = this.$store.state.interupt;
      if (typeof rupt === 'string') {
        return 'regular';
      } else {
        return rupt.type;
      }
    }
  },
  mounted: function mounted() {
    if (window.ga) {
      window.ga('send', 'event', 'Info popup', 'open', 'At ' + this.$route.path);
    }
  },

  components: {}
});

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loader',
  data: function data() {
    return {
      msg: 'Welcome to Your Vue.js App'
    };
  },

  props: ['colorClass']
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_geolocator__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_geolocator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_geolocator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_geolib__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_geolib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_geolib__);





var locationWatcher = false;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'location',
  data: function data() {
    return {
      firstTime: true
    };
  },

  computed: {
    userLocation: function userLocation() {
      return this.$store.state.userLocation;
    },
    locationError: function locationError() {
      return this.$store.state.locationError;
    },
    areas: function areas() {
      return this.$store.state.areas;
    },
    currentArea: function currentArea() {
      return this.$store.state.currentArea;
    }
  },
  methods: {
    watchLocation: function watchLocation() {
      var _this = this;

      locationWatcher = __WEBPACK_IMPORTED_MODULE_0_geolocator___default.a.watch({
        enableHighAccuracy: true,
        timeout: 5000,
        maximumWait: 10000,
        maximumAge: 0,
        desiredAccuracy: 1,
        fallbackToIP: false,
        addressLookup: false,
        timezone: false
      }, function (err, location) {
        if (err) {
          _this.$store.commit('changeLocationError', true);
          return console.log(err);
        }
        _this.$store.commit('changeLocationError', false);
        var userLocation = {
          lat: location.coords.latitude,
          lng: location.coords.longitude
        };
        _this.$store.commit('changeUserLocation', userLocation);

        window.setTimeout(function () {
          _this.$store.commit('setLocationHasBeenLoaded', true);
        }, 4000);
      });
    },
    setupGeolocation: function setupGeolocation() {
      __WEBPACK_IMPORTED_MODULE_0_geolocator___default.a.config({
        language: 'en',
        google: {
          version: '3',
          key: 'AIzaSyBP498t5dAbPMm_x9CsRzGxSK_wrtZtOnc'
        }
      });
    },
    checkUserCurrentArea: function checkUserCurrentArea() {
      for (var i = 0; i < this.areas.length; i++) {
        var areaName = this.areas[i].key;
        var areaTalkName = this.areas[i].name;
        var point = {
          latitude: this.userLocation.lat,
          longitude: this.userLocation.lng
        };
        var polygon = this.areas[i].coordinates.map(function (a) {
          var coordinate = {
            latitude: a.lat,
            longitude: a.lng
          };
          return coordinate;
        });
        var isinside = __WEBPACK_IMPORTED_MODULE_1_geolib___default.a.isPointInside(point, polygon);
        if (isinside) {
          this.$store.commit('setCurrentAreaName', areaTalkName);
          this.$store.commit('setCurrentArea', areaName);

          return true;
        }
      }
      this.$store.commit('setCurrentArea', null);
    }
  },
  mounted: function mounted() {
    this.watchLocation();
  },

  watch: {
    userLocation: function userLocation(val) {
      this.checkUserCurrentArea();
    },
    areas: function areas() {
      this.checkUserCurrentArea();
    },
    currentArea: function currentArea(val, oldVal) {
      if (oldVal === null && val !== null) {
        if (!this.firstTime || this.$route.path === '/map') {
          this.firstTime = false;
          var areaName = this.$store.state.currentAreaName;
          if (this.$store.state.locationHasBeenLoaded || this.$store.state.hasBeenToStart) {
            if (this.$route.path === '/map') {
              this.$store.commit('interupt', 'Du har tagit dig till fotoområdet ' + areaName + '! <h6>Sätt på dina AR-glasögon för att hitta de fem fotoplatserna i området. AR-glasögonen finns i din kameraväska.</h6>');
            }
          }
        }
      }
      this.$store.dispatch('fetchSpots', { areaKey: val });
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (locationWatcher !== false) {
      locationWatcher.clear();
    }
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  data: function data() {
    return {
      list: [{
        title: 'Report',
        subtitle: 'Report a bug or suggest an improvement'
      }]
    };
  },

  methods: {},
  mounted: function mounted() {}
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photoUpload',
  data: function data() {
    return {
      view: 'upload',
      isSaving: false,
      isUploading: false,
      first: true,
      tip: {
        title: '...',
        body: '...'
      }
    };
  },

  computed: {
    atSpot: function atSpot() {
      return this.$store.state.atSpot;
    },
    userHasPhotoAtSpot: function userHasPhotoAtSpot() {
      return this.$store.getters.userHasPhotoAtSpot;
    },
    user: function user() {
      return this.$store.state.user;
    },
    uploading: function uploading() {
      return this.$store.state.uploadingPhoto;
    },
    uploadingPhotoProgress: function uploadingPhotoProgress() {
      return parseInt(this.$store.state.uploadingPhotoProgress);
    },
    userOS: function userOS() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return 'windowsphone';
      }
      if (/android/i.test(userAgent)) {
        return 'android';
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
      }
      return false;
    }
  },
  methods: {
    openInGoogle: function openInGoogle() {
      if (window.ga) {
        window.ga('send', 'event', 'Open app', 'open', 'Open Lightroom Android');
      }
    },
    openInIos: function openInIos() {
      if (window.ga) {
        window.ga('send', 'event', 'Open app', 'open', 'Open Lightroom iOS');
      }
      var windowExt = window.open('http://exhibitionstockholm.se/deep.html');
      window.setTimeout(function () {
        windowExt.close();
      }, 2000);
    },
    saving: function saving() {
      this.isSaving = true;
    },
    close: function close() {
      this.$store.commit('showingPhotoUpload', false);
    },
    selectFile: function selectFile(e) {
      this.isSaving = true;
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        this.isSaving = false;
        return;
      }
      this.createImageAndThumbnail(files[0]);
    },
    randomPhotoTip: function randomPhotoTip() {
      var photoTips = [{
        title: 'Vibrance (Lyster)',
        body: 'Används för att antingen ge lite extra ”stuns” till eller tona ner färgerna i en bild.'
      }, {
        title: 'Kontrast',
        body: 'Används för att justera ”avståndet” mellan en bilds ljusa och mörka delar. Ju starkare kontrast du ställer in, desto ljusare blir de ljusa delarna och desto mörkare de mörka. Genom att justera kontrasten och på så sätt förstärka färgskillnaderna går det att öka ”djupet” i bilden.'
      }, {
        title: 'Exposure (Intensitet – Ljusstyrka)',
        body: 'Används för att göra alla färger i en bild antingen ljusare eller mörkare. Fungerar bra som komplement till kontrast. '
      }, {
        title: 'Crop (Beskärning)',
        body: 'Används för att beskära en bild.'
      }, {
        title: 'Saturation',
        body: 'Används för att göra färger i en bild mer eller mindre intensiva.'
      }, {
        title: 'Clarity',
        body: 'Används för åstadkomma ett större djup, eller mer av en 3D-känsla, i en bild.'
      }, {
        title: 'Whites & Highlights',
        body: 'När du justerar ”Whites” förstärks eller försvagas de vitaste och ljusaste pixlarna i en bild. Med ”Highlights” justeras endast de ljusa pixlar som inte är vita.'
      }, {
        title: 'Black & Shadows',
        body: 'När du justerar ”Black” förstärks eller försvagas de svartaste och mörkaste pixlarna i bilden. Med ”Shadows” justeras endast de mörka pixlar som inte är svarta. Exempelvis kan du tona skuggorna i en bild'
      }, {
        title: 'RAW-format',
        body: 'När du fotar i RAW-format sparas all så kallad rådata i bilden. En stor fördel med att spara datan är att du kan redigera bilden utan att den förlorar i kvalitet.'
      }, {
        title: 'Tint',
        body: 'Används för att styra färgtonen i bilden.'
      }, {
        title: 'Dehaze',
        body: 'Används för att ta bort eller öka ”dimmighet” i din bild. Dehaze är ett bra verktyg för att göra en bild mer skarp.'
      }, {
        title: 'Shutterspeed (Slutartid)',
        body: 'Används för att reglera andelen ljus som kameran tar in. Exempel: Om du vill ta en bild på något i rörelse och ställer in kort slutartid kommer objektet upplevas som att det är ”fryst” i rörelsen. Fotar du samma objekt i rörelse med lång slutartid kommer hela rörelsen synas och objektet bli suddigt.'
      }, {
        title: 'Rengör linsen',
        body: 'Mobilbilder kan ofta få ett betydligt lyft av något så enkelt som en ren kameralins. Se till att regelbundet rengöra den med en liten putsduk.'
      }, {
        title: 'Kom igång med Lightroom Mobile',
        body: '<a href="https://helpx.adobe.com/lightroom/how-to/lightroom-mobile.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
      }, {
        title: 'Så fotar du bäst med Lightroom Mobile',
        body: '<a href="https://helpx.adobe.com/lightroom/how-to/camera-effects-lightroom-mobile.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
      }, {
        title: 'Så fotar du i raw i Lightroom Mobile',
        body: '<a href="https://helpx.adobe.com/lightroom/how-to/raw-file-mobile-photo-editor-app.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
      }, {
        title: 'Så redigerar du bilder i Lightroom Mobile',
        body: '<a href="https://helpx.adobe.com/lightroom/how-to/lightroom-mobile-adjustments.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
      }, {
        title: 'Lär dig justera färgerna korrekt i Lightroom Mobile',
        body: '<a href="https://helpx.adobe.com/lightroom/how-to/color-adjustment.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
      }, {
        title: 'Återskapa samma redigering i Lightroom Mobile',
        body: '<a href="https://helpx.adobe.com/lightroom/how-to/edit-photos-lightroom-mobile-photoshop-fix.html" target="_blank" style="color: inherit; text-decoration: underline;">Läs guide här.</a>'
      }];
      var randNr = Math.floor(Math.random() * photoTips.length);
      return photoTips[randNr];
    },
    createImageAndThumbnail: function createImageAndThumbnail(file) {
      var _this = this;

      var reader = new FileReader();
      var canvas = document.getElementById('thumb-canvas');
      var ctx = canvas.getContext('2d');
      reader.onload = function (e) {
        document.getElementById('preview-image').style.backgroundImage = 'url(' + e.target.result + ')';
        var thumb = new Image();
        thumb.onload = function () {
          _this.view = 'confirm';
          canvas.width = 600;
          canvas.height = 600 * thumb.height / thumb.width;
          if (thumb.height > thumb.width) {
            canvas.className += ' portrait';
          }
          ctx.drawImage(thumb, 0, 0, 600, 600 * thumb.height / thumb.width);
          var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
          if (iOS) {
            _this.getOrientation(file, function (result) {
              _this.drawRotated(result, ctx, canvas, thumb);
            });
          }
        };
        thumb.src = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    drawRotated: function drawRotated(degreeNr, ctx, canvas, image) {
      var degree = 0;
      switch (degreeNr) {
        case 1:
          degree = 0;
          break;
        case 2:
          degree = 0;
          break;
        case 3:
          degree = 180;
          break;
        case 4:
          degree = 180;
          break;
        case 5:
          degree = 90;
          canvas.height = 600 * image.width / image.height;
          break;
        case 6:
          degree = 90;
          canvas.height = 600 * image.width / image.height;
          break;
        case 7:
          degree = 270;
          canvas.height = 600 * image.width / image.height;
          break;
        case 8:
          degree = 270;
          canvas.height = 600 * image.width / image.height;
          break;
      }
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.setTransform(1, 0, 0, 1, canvas.width / 2, canvas.height / 2);
      ctx.rotate(degree * Math.PI / 180);
      var imageW = 600;
      var imageH = 600 * image.height / image.width;
      ctx.drawImage(image, -imageW / 2, -imageH / 2, imageW, imageH);
    },
    redo: function redo() {
      this.isSaving = false;
      this.view = 'upload';
      document.getElementById('fileupload-input').value = '';
      document.getElementById('preview-image').style.backgroundImage = 'none';
    },
    getOrientation: function getOrientation(file, callback) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var view = new DataView(e.target.result);
        if (view.getUint16(0, false) !== 0xFFD8) return callback(-2);
        var length = view.byteLength;
        var offset = 2;
        while (offset < length) {
          var marker = view.getUint16(offset, false);
          offset += 2;
          if (marker === 0xFFE1) {
            if (view.getUint32(offset += 2, false) !== 0x45786966) return callback(-1);
            var little = view.getUint16(offset += 6, false) === 0x4949;
            offset += view.getUint32(offset + 4, little);
            var tags = view.getUint16(offset, little);
            offset += 2;
            for (var i = 0; i < tags; i++) {
              if (view.getUint16(offset + i * 12, little) === 0x0112) {
                return callback(view.getUint16(offset + i * 12 + 8, little));
              }
            }
          } else if ((marker & 0xFF00) !== 0xFF00) {
            break;
          } else {
            offset += view.getUint16(offset, false);
          }
        }
        return callback(-1);
      };
      reader.readAsArrayBuffer(file);
    },
    uploadImage: function uploadImage() {
      this.isUploading = true;
      var files = document.getElementById('fileupload-input').files;
      if (!files.length) {
        return;
      }
      var fileName = this.makeImageId(32);
      var thumbCanvas = document.getElementById('thumb-canvas');
      var thumb = thumbCanvas.toDataURL('image/jpeg', 0.9);
      var thumbFile = this.dataURItoBlob(thumb);

      this.$store.dispatch('uploadPhoto', { file: files[0], thumb: thumbFile, fileName: fileName, isFirst: this.first });
    },
    makeImageId: function makeImageId(size) {
      var text = '';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < size; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
    dataURItoBlob: function dataURItoBlob(dataURI) {
      var byteString = void 0;
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = window.atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ia], { type: mimeString });
    }
  },
  mounted: function mounted() {
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Photo Upload');
    }

    if (this.userHasPhotoAtSpot) {
      this.first = false;
      this.$store.commit('interupt', 'Du håller på att byta ut ditt foto på ' + this.atSpot[0] + '<h6>Du får bara tävla med en bild i taget på varje fotoplats. Om du byter ut din nuvarande bild kommer poängen du fått för bilden att försvinna. Om du är säker på att du vill fortsätta, tryck på Ladda upp foto.');
    }
    this.tip = this.randomPhotoTip();
  },
  beforeDestroy: function beforeDestroy() {
    this.view = 'upload';
  },

  components: {}
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_photoFeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Db__ = __webpack_require__(1);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'spotdistance',
  data: function data() {
    return {
      spotPhotosLoaded: false,
      photos: []
    };
  },

  props: ['spot'],
  computed: {
    photosOrdered: function photosOrdered() {}
  },
  methods: {
    close: function close() {
      this.$store.commit('updateSpotAtDistance', null);
    },
    getPhotosFromSpot: function getPhotosFromSpot() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('photos/' + this.spot).orderByChild('score').limitToLast(29).once('value').then(function (snapshot) {
        _this.spotPhotosLoaded = true;
        snapshot.forEach(function (shot) {
          _this.photos.push(shot.val());
        });
      });
    }
  },
  mounted: function mounted() {
    this.getPhotosFromSpot();
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Spot from distance');
    }
  },
  beforeDestroy: function beforeDestroy() {},

  components: { loader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a, photoFeed: __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default.a }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Db_js__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_thend_json__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__json_thend_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__json_thend_json__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'start',
  data: function data() {
    return {
      msg: 'EXHIBITION STOCKHOLM',
      winnerSlides: [],
      hasDisCookie: false
    };
  },

  computed: {
    test: function test() {
      return this.$store.state.userLocation.lat;
    }
  },
  beforeMount: function beforeMount() {
    if (this.$store.state.needsReload === true) {
      this.$store.commit('setNeedsReload', false);
      location.reload();
    }
    this.$store.commit('changeShowMenu', false);
  },
  mounted: function mounted() {
    if (window.localStorage) {
      var hasSeenCookie = window.localStorage.getItem('hasSeenCookie');
      if (hasSeenCookie !== null) {
        this.hasDisCookie = true;
      }
    }
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Start landing');
    }
    this.$store.commit('setHasBeenToStart', true);

    this.getWinnersJson();
    this.makeCollage();
  },

  methods: {
    toGooglePlay: function toGooglePlay() {
      if (window.ga) {
        window.ga('send', 'event', 'Link', 'click', 'Lightroom Google Play');
      }
    },
    toAppStore: function toAppStore() {
      if (window.ga) {
        window.ga('send', 'event', 'Link', 'click', 'Lightroom App store');
      }
    },
    userOS: function userOS() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (/windows phone/i.test(userAgent)) {
        return 'windowsphone';
      }
      if (/android/i.test(userAgent)) {
        return 'android';
      }
      if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'ios';
      }
      return false;
    },
    testingTouch: function testingTouch(e) {},
    closeCookie: function closeCookie() {
      var elem = document.getElementById('cookie-dis');
      if (window.localStorage) {
        window.localStorage.setItem('hasSeenCookie', true);
      }
      return elem.parentNode.removeChild(elem);
    },
    makeCollage: function makeCollage() {
      console.log('making collage');
    },
    getRandomPos: function getRandomPos(index) {
      var top = 0;
      var left = 0;
      top = index * 11;
      left = screen.width * Math.random() - 50;
      return [top, left];
    },
    getRandomSize: function getRandomSize(index) {
      var width = 400 * Math.random() + 30;
      var height = 400 * Math.random() + 30;
      return [width, height];
    },
    getWinners: function getWinners() {
      var _this = this;

      var winners = [];
      __WEBPACK_IMPORTED_MODULE_0__classes_Db_js__["a" /* default */].database().ref('winner').once('value').then(function (snapshot) {
        snapshot.forEach(function (photo) {
          var photoVal = photo.val();
          winners.push(photoVal);
        });
        winners.sort(function (a, b) {
          if (a.score < b.score) {
            return 1;
          }
          if (a.score > b.score) {
            return -1;
          }
          return 0;
        });
        _this.winnerSlides = winners.slice(0, 10);
        _this.$nextTick(function () {
          window.$('.winner-slides').slick({
            dots: false,
            arrows: false,
            infinite: true,
            autoplay: true
          });
        });
      });
    },
    getWinnersJson: function getWinnersJson() {
      this.winnerSlides = __WEBPACK_IMPORTED_MODULE_1__json_thend_json___default.a;
      this.$nextTick(function () {
        window.$('.winner-slides').slick({
          dots: false,
          arrows: false,
          infinite: true,
          autoplay: true
        });
      });
    },
    openRegler: function openRegler() {
      if (window.ga) {
        window.ga('send', 'event', 'Page', 'enter', 'Regler & poäng');
      }
      var htmlString = '';

      htmlString = '<h1>TÄVLINGSREGLER OCH POÄNGSYSTEM</h1>';
      htmlString += '1. Du måste vara över 18 år för att delta.<br><br>2. Du får använda vilken kamera och vilket redigeringsverktyg du vill. (Använd gärna din telefon. Använder du den på rätt sätt lovar vi att du kan du sätta skräck i fotoproffsen. Vi ger dig tips på hur du utvecklar dina foton under vägen.)<br><br>3. Du får endast ladda upp bilder som du själv är upphovsman till. En bild kan endast ladda upp på en fotoplats och den måste vara tagen på fotoplatsen.<br><br>4. Du får ladda upp fler än en bild på en fotoplats, men det är endast din senast uppladdade bild du tävlar med. Du får 20 poäng för din första uppladdade bild på varje fotoplats.<br><br>5. Du får inte ladda upp bilder med olämpligt innehåll. För mer information om vad vi anser vara olämpligt innehåll, se våra användningsvillkor där du även hittar samtliga regler i sin helhet.<br><br>6. För varje ny fotoplats du hittar får du 10 poäng. <br><br>För varje ny fotoplats som du tar och laddar upp en bild på får du 20 poäng.<br><br>Efter att du fått minst fem röster på en bild kommer du få mellan 0 och 100 poäng för bilden baserat på hur andra röster på din bild. Antalet poäng på en bild kan ändras hela vägen fram till tävlingens slut och är procentuellt baserat på andelen positiva röster i förhållande till samtliga röster på bilden; exempelvis ger sju positiva av totalt tio röster 70 poäng.<br><br>7. Deltagaren med flest poäng vid tävlingens slut vinner tävlingen och 30 000 SEK i prispengar. 2-10 pristagarna vinner en årsprenumeration på Creative Cloud fotografi, värd 1433 SEK. De 54 bilder med högst poäng på varje fotoplats ställs ut i en augmented reality-utställning i Kungsträdgården, 21 - 27 augusti. Inget av priserna kan bytas ut mot pengar eller annat. Samtliga vinnare notifieras via e-post.';
      this.$store.commit('openTextPage', htmlString);
    },
    openTerms: function openTerms() {
      this.$store.commit('openTextPage', 'terms');
      this.$store.commit('setShowAgreement', true);
    },
    openSupport: function openSupport() {
      if (window.ga) {
        window.ga('send', 'event', 'Page', 'enter', 'Support');
      }
      var htmlString = '';
      htmlString = '<h1>Kontakta Support</h1>';
      htmlString += 'Har du tekniska problem med webbapplikationen, har du frågor eller vill du rapportera olämpligt material? Skriv till oss på <a href="mailto:support@exhibitionstockholm.se" target="_blank">support@exhibitionstockholm.se</a>';
      this.$store.commit('openTextPage', htmlString);
    },
    openOm: function openOm() {
      if (window.ga) {
        window.ga('send', 'event', 'Page', 'enter', 'Om Adobe');
      }
      var htmlString = '';
      htmlString = '<h1>Om Adobe</h1>';
      htmlString += 'Adobe förändrar världen genom digitala upplevelser. Läs mer på <a href="http://www.adobe.com" target="_blank">www.adobe.com</a>';
      this.$store.commit('openTextPage', htmlString);
    }
  },
  beforeDestroy: function beforeDestroy() {}
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'textpage',
  computed: {
    textPageContent: function textPageContent() {
      return this.$store.state.textPageContent;
    },
    showAgreement: function showAgreement() {
      return this.$store.state.showAgreement;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('openTextPage', null);
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.commit('setShowAgreement', false);
  },

  components: {}
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_photoFeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Db__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'winnerFeed',
  data: function data() {
    return {
      browsing: true,
      photosLoaded: false,
      winnerPhotos: []
    };
  },

  computed: {
    winnerString: function winnerString() {
      var winners = [];
      winners = this.winnerPhotos.map(function (a, i) {
        return a.username;
      });
      var filtered = [];
      for (var i = 0; i < winners.length; i++) {
        if (filtered.indexOf(winners[i]) === -1) {
          filtered.push(winners[i]);
        }
      }
      return filtered.sort(function (a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      });
    }
  },
  methods: {
    close: function close() {
      window.location.href = 'https://game.exhibitionstockholm.se';
    },
    browsePhotos: function browsePhotos() {
      this.browsing = true;
    },
    getAllWinners: function getAllWinners() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('finalwinners').once('value', function (snapshot) {
        snapshot.forEach(function (child) {
          _this.winnerPhotos.push(child.val());
        });
        _this.photosLoaded = true;
        console.log(_this.winnerPhotos);
      });
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.getAllWinners();
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Winner Feed');
    }
  },
  beforeDestroy: function beforeDestroy() {},

  components: { loader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a, photoFeed: __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default.a }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'errupt',
  computed: {},
  mounted: function mounted() {},

  methods: {
    laddaOmSida: function laddaOmSida() {
      window.location.reload();
    },
    openHowGPS: function openHowGPS() {
      var htmlString = '<h1>Hur ger jag tillåtelse</h1><p>1.</p><p>2.</p>';
      this.$store.commit('openTextPage', htmlString);
    },
    openpopup: function openpopup() {
      var htmlString = '<h1>Godkänn att spelet använder platsinformation</h1><p>Det är möjligt att du råkat avböja spelets förfrågan om att få tillgång till din platsinformation.</p> Se till att webbplatsen är godkänd att använda platsinformation.';
      this.$store.commit('openTextPage', htmlString);
    },
    openTurnOn: function openTurnOn() {
      var html = '<h1>Besöker du sidan genom facebooks webbläsare?</h1><br>Då måste du välja att öppna sidan i din telefons vanliga webbläsare. Det gör du genom att antingen kopiera länken in i din vanliga webbläsare eller trycka på menyn uppe till höger där du kan välja att göra detta<br><br>';
      html += '<h1>Så här aktiverar du mobilens platstjänster</h1>';
      html += '<br><b>Aktivera platstjänster på Apple iOS</b><br>';
      html += '<ol>';
      html += '<li>Öppna inställningar. Leta efter appen inställningar på din iOS-enhet och tryck på den.</li>';
      html += '<li>Gå till platstjänster. Tryck på "Sekretess" i menyn Inställningar och tryck sedan på "Platstjänster".</li>';
      html += '<li>Välj att aktivera platstjänster.</li>';
      html += '<li>Välj sedan att aktivera för din webbläsare tex. Safari, google chrome eller firefox.</li>';
      html += '</ol>';
      html += '<br><br>';
      html += '<b>Aktivera platstjänster på Android</b><br>';
      html += '<ol>';
      html += '<li>Gå till Inställningar och sedan Platstjänster:';
      html += '<ul><li>Vid använd trådlösa nätverk: Välj att aktivera</li><li>Vid använd GPS-satelliter: Välj att aktivera</li><li>Vid plats och Google-sökning: Välj att aktivera</li></ul>';
      html += '<li>I menyn gå till internet, tryck på menyknappen, välj sekretess sedan säkerhet och sist plats</li>';
      html += '<li>Tillåt platsåtkomst: Aktivera</li>';
      html += '</ol>';
      html += '<br>Nu borde du få en notifikation i din webbläsare när hemsidan frågar efter din plats.';
      this.$store.commit('openTextPage', html);
    },
    openGPSTerms: function openGPSTerms() {
      var htmlString = '<h1>Hur används min platsinformation?</h1><p>lsls</p><p>lal</p>';
      this.$store.commit('openTextPage', htmlString);
    }
  },
  components: {}
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Modal__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'infoMenu',
  data: function data() {
    return {
      list: [{
        title: 'v1.0 Exhibition Stockholm',
        subtitle: '29 June 2017'
      }]
    };
  },

  computed: {
    bugReport: function bugReport() {
      return this.$store.state.bugReport;
    }
  },
  methods: {
    close: function close() {},
    reportABug: function reportABug() {
      if (window.ga) {
        window.ga('send', 'event', 'Report', 'open', 'Bug Report');
      }
      var text = document.getElementById('bugreport-text').value;
      if (text.length < 1) {
        this.$store.commit('interupt', 'Skriv nått innan du skickar in!');
      } else {
        this.$store.dispatch('reportABug', {
          text: text
        });
      }
    }
  },
  mounted: function mounted() {
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Info Menu');
    }
  },

  components: { modal: __WEBPACK_IMPORTED_MODULE_0__components_Modal___default.a }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photo',
  data: function data() {
    return {
      msg: 'Jag heter Pär och jag är bäst på javasscript'
    };
  },

  computed: {
    singlePhoto: function singlePhoto() {
      return this.$store.state.singlePhoto;
    }
  },
  methods: {
    close: function close() {
      this.$store.commit('setSinglePhoto', null);
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__classes_Db__ = __webpack_require__(1);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photoFeed',
  data: function data() {
    return {
      msg: '',
      voted: null
    };
  },

  props: ['photos', 'showUser', 'showSpot'],
  computed: {
    winnerString: function winnerString() {
      return this.photos.map(function (a, i) {
        return a.username;
      });
    },
    singlePhoto: function singlePhoto() {
      return this.$store.state.singlePhoto;
    },
    photosReversed: function photosReversed() {
      var sliced = this.photos.slice();
      var list = sliced.reverse();
      if (this.showUser === 'true') {
        return list;
      }
      if (this.showSpot === true) {
        return list;
      } else {
        return list.slice(0, 29);
      }
    }
  },
  methods: {
    makeSpotWinner: function makeSpotWinner(photo) {
      this.voted = photo.id;
      __WEBPACK_IMPORTED_MODULE_0__classes_Db__["a" /* default */].database().ref('finalwinners/' + photo.id).set(photo);
    },
    popSpot: function popSpot(name) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit('updateSpotAtDistance', name);
    },
    close: function close() {
      this.$store.commit('setSinglePhoto', null);
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_photoFeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classes_Db__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'singleFeed',
  data: function data() {
    return {
      browsing: true,
      photosLoaded: false,
      winnerPhotos: [],
      photographer: 'Hämtar...'
    };
  },

  props: ['photoid'],
  methods: {
    close: function close() {
      this.$emit('close');
    },
    browsePhotos: function browsePhotos() {
      this.browsing = true;
    },
    getWinner: function getWinner() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2__classes_Db__["a" /* default */].database().ref('finalwinners/' + this.photoid).once('value', function (snapshot) {
        var valn = snapshot.val();
        _this.winnerPhotos.push(valn);
        _this.photographer = valn.username;
        _this.photosLoaded = true;
      });
    }
  },
  mounted: function mounted() {
    window.scrollTo(0, 0);
    this.getWinner();
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Single Winner Feed');
    }
  },
  beforeDestroy: function beforeDestroy() {},

  components: { loader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a, photoFeed: __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default.a }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_photoFeed__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'spot',
  data: function data() {
    return {
      browsing: false
    };
  },

  computed: {
    atSpot: function atSpot() {
      return this.$store.state.atSpot;
    },
    atSpotPhotos: function atSpotPhotos() {
      return this.$store.state.atSpotPhotos;
    },
    atSpotPhotosLoaded: function atSpotPhotosLoaded() {
      return this.$store.state.atSpotPhotosLoaded;
    },
    user: function user() {
      return this.$store.state.user;
    },
    atSpotWinner: function atSpotWinner() {
      return this.$store.state.atSpotWinner;
    },
    userHasPhotoAtSpot: function userHasPhotoAtSpot() {
      return this.$store.getters.userHasPhotoAtSpot;
    },
    userVisitedSpots: function userVisitedSpots() {
      return this.$store.state.userVisitedSpots;
    }
  },
  methods: {
    close: function close() {
      if (this.browsing === true) {
        this.browsing = false;
      } else {
        this.$store.dispatch('setAtSpot', { spotname: null, distance: 0 });
      }
    },
    challangePhoto: function challangePhoto() {
      this.$store.commit('showingPhotoUpload', true);
    },
    browsePhotos: function browsePhotos() {
      this.browsing = true;
    }
  },
  mounted: function mounted() {
    if (window.ga) {
      window.ga('send', 'event', 'Page', 'enter', 'Spot');
    }

    if (this.user !== null) {
      this.$store.dispatch('addUserVisitedSpot', {
        areaKey: this.$store.state.currentArea,
        spot: this.$store.state.atSpot[0]
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.$store.dispatch('setAtSpot', { spotname: null, distance: 0 });
    this.$store.commit('setAtSpotPhotosLoaded', false);
  },

  components: { loader: __WEBPACK_IMPORTED_MODULE_0__components_Loader___default.a, photoFeed: __WEBPACK_IMPORTED_MODULE_1__components_photoFeed___default.a }
});

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 67 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 70 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 75 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 76 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 77 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 78 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAzMC45IDMwLjYiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMwLjkgMzAuNjsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6Izk5OTk5OTt9DQo8L3N0eWxlPg0KPGc+DQoJPGc+DQoJCTxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik0xNS41LDJjNC4xLDAsNy40LDMuMyw3LjQsNy40cy0zLjMsNy40LTcuNCw3LjRTOCwxMy41LDgsOS40UzExLjQsMiwxNS41LDIgTTE1LjUsMEMxMC4zLDAsNiw0LjIsNiw5LjQNCgkJCXM0LjIsOS40LDkuNCw5LjRzOS40LTQuMiw5LjQtOS40UzIwLjcsMCwxNS41LDBMMTUuNSwweiIvPg0KCTwvZz4NCgk8Zz4NCgkJPHBhdGggY2xhc3M9InN0MCIgZD0iTTE1LjUsMjAuMmM1LjcsMCwxMC41LDMuNSwxMi41LDguNEgzQzUsMjMuNyw5LjgsMjAuMiwxNS41LDIwLjIgTTE1LjUsMTguMmMtNi4zLDAtMTIsMy44LTE0LjQsOS43TDAsMzAuNmgzDQoJCQloMjVoM2wtMS4xLTIuOEMyNy40LDIyLDIxLjgsMTguMiwxNS41LDE4LjJMMTUuNSwxOC4yeiIvPg0KCTwvZz4NCjwvZz4NCjwvc3ZnPg0K"

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(73)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(28),
  /* template */
  __webpack_require__(119),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(67)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(29),
  /* template */
  __webpack_require__(113),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(74)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(30),
  /* template */
  __webpack_require__(120),
  /* scopeId */
  "data-v-d776909a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(75)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(31),
  /* template */
  __webpack_require__(121),
  /* scopeId */
  "data-v-df012996",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(71)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(32),
  /* template */
  __webpack_require__(117),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(64)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(34),
  /* template */
  __webpack_require__(110),
  /* scopeId */
  "data-v-37468b0d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(35),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  "data-v-093a3b85",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(78)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(124),
  /* scopeId */
  "data-v-f6730eaa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(68)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(114),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  "data-v-08fb22ba",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(69)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(115),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(66)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(112),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(72)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(118),
  /* scopeId */
  "data-v-c6d16528",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(70)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(116),
  /* scopeId */
  "data-v-5c39fb36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(65)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(111),
  /* scopeId */
  "data-v-442fd6ac",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(62)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(108),
  /* scopeId */
  "data-v-0dbd38be",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(76)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(122),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-inside"
    }
  }, [(_vm.textPage !== null) ? _c('textPage') : _vm._e(), _vm._v(" "), (this.$store.state.spotAtDistance !== null && (_vm.$route.name === 'map' || _vm.$route.name === 'profile')) ? _c('spotdistance', {
    attrs: {
      "spot": this.$store.state.spotAtDistance
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locationError && _vm.currentRoute !== 'start') ? _c('errupt') : _vm._e(), _vm._v(" "), (_vm.interupt !== null) ? _c('interupt') : _vm._e(), _vm._v(" "), (_vm.$route.name !== 'start' && _vm.$route.name !== 'tutorial') ? _c('location') : _vm._e(), _vm._v(" "), _c('auth'), _vm._v(" "), (_vm.infoMenu) ? _c('info-menu') : _vm._e(), _vm._v(" "), (_vm.singlePhoto !== null) ? _c('photo') : _vm._e(), _vm._v(" "), (_vm.showingPhotoUpload) ? _c('photo-upload') : _vm._e(), _vm._v(" "), (_vm.showingOverlay === true) ? _c('spot', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showingPhotoUpload === false),
      expression: "showingPhotoUpload === false"
    }]
  }) : _vm._e(), _vm._v(" "), (_vm.textPage === null) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "slide-rotate-fade"
    }
  }, [(_vm.showMenu === false && _vm.$route.name === 'map') ? _c('div', {
    staticClass: "float-toggle",
    on: {
      "click": function($event) {
        _vm.$store.commit('changeShowMenu', true)
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.showMenu === true && _vm.$route.name === 'map') ? _c('float-menu') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view start-view"
  }, [(_vm.hasDisCookie === false) ? _c('div', {
    staticClass: "cookiepop",
    attrs: {
      "id": "cookie-dis"
    }
  }, [_vm._v("Vi använder cookies för att ge dig bästa möjliga upplevelse. Genom att använda webbplatsen accepterar du att cookies används. "), _vm._m(0), _c('div', {
    staticClass: "cookie-close",
    on: {
      "click": _vm.closeCookie
    }
  }, [_vm._v("✕")])]) : _vm._e(), _vm._v(" "), ( false) ? _c('div', {
    staticClass: "section",
    attrs: {
      "id": "collage"
    }
  }, _vm._l((_vm.winnerSlides), function(slide, index) {
    return _c('div', {
      staticClass: "collage-item",
      style: ({
        backgroundImage: 'url(' + './static/min/' + slide.image + ')',
        top: (_vm.getRandomPos(index))[0] + 'px',
        left: (_vm.getRandomPos(index))[1] + 'px',
        height: (_vm.getRandomSize(index))[1] + 'px',
        width: (_vm.getRandomSize(index))[0] + 'px'
      })
    })
  })) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "section",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "table-cell start-section"
  }, [_c('div', {
    staticClass: "smile smile-crown"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-crop"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-key"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-sun"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-camera"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-levers"
  }), _vm._v(" "), _c('div', {
    staticClass: "smile smile-squares"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "exs-title"
  }, [_vm._v("\r\n              Exhibition\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "exs-sub-title"
  }, [_vm._v("\r\n              Stockholm\r\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "new-logo"
  }), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "blue-butt",
    staticStyle: {
      "font-size": "0.9em"
    },
    attrs: {
      "to": "/winners"
    }
  }, [_vm._v("Se utställda foton 2017")]), _c('br'), _c('br')], 1)])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "padding-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "winner-slides"
  }, _vm._l((_vm.winnerSlides), function(slide) {
    return _c('div', {
      staticClass: "winner-slide",
      style: ({
        backgroundImage: 'url(' + './static/min/' + slide.image + ')'
      })
    }, [_c('div', {
      staticClass: "winner-text"
    }, [_c('div', {
      staticClass: "blue-circle"
    }), _vm._v(" "), _c('span', {
      staticClass: "spot-title"
    }, [_vm._v(_vm._s(slide.spot))]), _vm._v(" av "), _c('b', [_vm._v(_vm._s(slide.username))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "inner-grid content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "iphone-mockup"
  }), _vm._v(" "), _c('div', {
    staticClass: "badge-group"
  }, [_c('a', {
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.adobe.lrmobile",
      "target": "_blank"
    },
    on: {
      "click": _vm.toGooglePlay
    }
  }, [_c('div', {
    attrs: {
      "id": "google-badge"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://appsto.re/se/EXsy0.i",
      "target": "_blank"
    },
    on: {
      "click": _vm.toAppStore
    }
  }, [_c('div', {
    attrs: {
      "id": "ios-badge"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "section start-bottom"
  }, [_c('div', {
    staticClass: "padding-20"
  }), _vm._v(" "), _c('ul', {
    staticClass: "bottom-menu"
  }, [_c('li'), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openRegler
    }
  }, [_vm._v("Tävlingsregler & poäng")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openTerms
    }
  }, [_vm._v("Användar- & tävlingsvillkor")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openSupport
    }
  }, [_vm._v("Support")]), _vm._v(" "), _c('li', {
    on: {
      "click": _vm.openOm
    }
  }, [_vm._v("Om Adobe")])]), _vm._v(" "), _c('br'), _vm._v("\r\n        Adobe 2017\r\n      ")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "http://www.adobe.com/se/privacy/cookies.html",
      "target": "_blank"
    }
  }, [_c('u', [_vm._v("Läs mer här")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section white-section",
    staticStyle: {
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "inner-grid"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', [_vm._v("\r\nTusentals fantastiska bilder laddades upp till Exhibition Stockholm. I den digitala utställningen länkad ovan kan ni se de bästa bilderna tagna på de olika fotoplatserna under tävlingens gång. Stort tack igen till alla som deltog och grattis till de vinnande bidragen!")]), _vm._v(" "), _c('p', [_vm._v("Om du har några frågor kontakta oss på "), _c('a', {
    staticStyle: {
      "color": "inherit"
    },
    attrs: {
      "href": "mailto:support@exhibitionstockholm.se"
    }
  }, [_c('u', [_vm._v("support@exhibitionstockholm.se")])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lightroom-group"
  }, [_c('div', {
    staticClass: "text-group"
  }, [_c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "lightroom-logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-black"
  }, [_vm._v("Skaffa"), _c('br'), _vm._v("Lightroom Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "padding-20"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-dark-grey"
  }, [_vm._v("Vill du ta dina mobilbilder till nästa nivå? Lär dig grunderna i fotoredigering! Det är lättare än du kanske tror."), _c('br'), _c('br'), _vm._v("Här kan du gratis ladda ned appen Lightroom Mobile. Med Lightroom Mobile kan du enkelt både ta och redigera bilder i din telefon. Exhibition Stockholm ger dig vassa och pedagogiska tips på hur du kan använda Lightroom Mobile för att fota och redigera bilder som proffsen.")]), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  })])])
}]}

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header", [_vm._v("\n            default header\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", [_vm._v("\n            default body\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer")], 2)])])])])
},staticRenderFns: []}

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view view-single-winner",
    attrs: {
      "id": "spot"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "browse"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Uställare 2017")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("Exhibition Stockholm")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-40 pad-sides"
  }, [_vm._v("\n      " + _vm._s(_vm.photographer) + "\n    ")]), _vm._v(" "), (_vm.photosLoaded === true) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_c('photoFeed', {
    attrs: {
      "photos": _vm.winnerPhotos,
      "show-user": "true"
    }
  }, [_c('div', {
    slot: "empty"
  }, [_vm._v("Något gick fel, prova ladda om sidan!")])])], 1) : _c('div', [_c('loader', {
    attrs: {
      "colorClass": "black"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])])
},staticRenderFns: []}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photofeed"
  }, [_c('div', {
    staticClass: "photo-list"
  }, [_vm._l((_vm.photosReversed), function(photo) {
    return (_vm.photos.length > 0) ? _c('div', {
      staticClass: "list list-photo"
    }, [_c('div', {
      staticClass: "thumb eye",
      style: ({
        backgroundImage: 'url(' + photo.thumburl + ')'
      }),
      on: {
        "click": function($event) {
          _vm.$store.dispatch('viewSinglePhoto', photo)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [(_vm.showSpot === 'true') ? _c('div', {}, [_c('div', {
      staticClass: "blue-circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "spot-link",
      on: {
        "click": function($event) {
          _vm.popSpot(photo.spot)
        }
      }
    }, [_vm._v(" " + _vm._s(photo.spot))]), _vm._v(" | "), (photo.score) ? _c('span', [_vm._v(_vm._s(photo.score) + "/100 poäng | " + _vm._s(photo.voteCount) + " röster")]) : _c('span', [_vm._v("färre än 5 röster")])]) : _vm._e(), _vm._v(" "), (_vm.showUser === 'true') ? _c('div', {
      staticClass: "username"
    }, [_c('div', {
      staticClass: "blue-circle"
    }), _vm._v(" "), _c('div', {
      staticClass: "spot-link"
    }, [_vm._v(" " + _vm._s(photo.spot))]), _vm._v(" av "), _c('b', [_vm._v(_vm._s(photo.username))]), _vm._v(" "), ( false) ? _c('div', {
      staticStyle: {
        "padding": "3px 15px",
        "background-color": "orange",
        "color": "#fff",
        "border-radius": "4px",
        "margin-left": "10px",
        "cursor": "pointer",
        "display": "inline-block"
      },
      on: {
        "click": function($event) {
          _vm.makeSpotWinner(photo)
        }
      }
    }, [_vm._v("GÖR TILL VINNARE!!")]) : _vm._e()]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), (_vm.photos.length == 0) ? _c('div', {
    staticClass: "empty list"
  }, [_vm._t("empty", [_vm._v("Inga foton.")])], 2) : _vm._e()], 2)])
},staticRenderFns: []}

/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "location"
  })
},staticRenderFns: []}

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "par view",
    style: ({
      backgroundImage: 'url(' + _vm.singlePhoto.thumburl + ')'
    })
  }, [_c('div', {
    staticClass: "close-but",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✕")]), _vm._v(" "), _c('div', {
    staticClass: "user-caption"
  })])
},staticRenderFns: []}

/***/ }),
/* 112 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.browsing === true) ? _c('div', {
    staticClass: "view",
    attrs: {
      "id": "spot"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "browse"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Uställare 2017")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("Exhibition Stockholm")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-40 pad-sides",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_vm._v("\n      Utställda fotografer\n    ")]), _vm._v(" "), _c('div', _vm._l((_vm.winnerString), function(winner, index) {
    return _c('div', {
      staticStyle: {
        "display": "inline-block",
        "margin-top": "5px"
      }
    }, [_vm._v("\n        " + _vm._s(winner)), (index !== 19) ? _c('span', [_vm._v(", ")]) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-40 pad-sides"
  }, [_vm._v("\n      Alla foton\n    ")]), _vm._v(" "), (_vm.photosLoaded === true) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_c('photoFeed', {
    attrs: {
      "photos": _vm.winnerPhotos,
      "show-user": "true"
    }
  }, [_c('div', {
    slot: "empty"
  }, [_vm._v("Något gick fel, prova ladda om sidan!")])])], 1) : _c('div', [_c('loader', {
    attrs: {
      "colorClass": "black"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "auth"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    attrs: {
      "id": "spot-distance"
    }
  }, [_c('div', {
    staticClass: "content",
    attrs: {
      "id": "browse"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Fotoplats")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "blue-circle"
  }), _vm._v(" " + _vm._s(_vm.spot))]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-40 pad-sides"
  }, [_vm._v("\n      Foton från platsen\n    ")]), _vm._v(" "), (_vm.spotPhotosLoaded === true) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_c('photoFeed', {
    attrs: {
      "photos": _vm.photos,
      "show-user": "true",
      "show-spot": "false"
    }
  }, [_c('div', {
    slot: "empty"
  }, [_vm._v("Inga foton från platsen.")])])], 1) : _c('div', [_c('loader', {
    attrs: {
      "colorClass": "black"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])])
},staticRenderFns: []}

/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textpage"
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": function($event) {
        _vm.$store.commit('openTextPage', null)
      }
    }
  }, [_vm._v("✖")]), _vm._v(" "), (_vm.showAgreement === false) ? _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.textPageContent)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showAgreement) ? _c('div', {
    staticClass: "user-agreement content"
  }, [_c('h1', [_vm._v("ANVÄNDAR- & TÄVLINGSVILLKOR")]), _vm._v(" "), _c('p', [_vm._v("Dessa villkor reglerar din användning av webbapplikationen Exhibition Stockholm samt ditt deltagande i och reglerna för tävlingen – Exhibition Stockholm och tävlingen tillhandahålls av Adobe Systems Incorporated (Adobe) - Adobe Systems Incorporated, 345 Park Avenue, San Jose, CA 95110-2704, Tel: 408-536-6000 (http://www.adobe.com/se/about-adobe/contact.html) \n")]), _c('p', [_vm._v("Genom att ansluta till och använda Exhibition Stockholm (webbapplikationen) bekräftar du att du läst och godkänt dessa villkor. \n")]), _vm._v(" "), _c('h2', [_vm._v("Webbapplikationen")]), _vm._v(" "), _c('p', [_vm._v("\nFör att deltaga i tävlingen Exhibition Stockholm använder du applikationen som nås på www.exhibitionstockholm.se. För att kunna använda applikationen och delta i fototävlingen med samma namn krävs inloggning med ett Facebook-konto. Genom att logga in med ett Facebook-konto ger du Adobe tillgång till ditt för- och efternamn samt e-postadress. Du behöver även tillgång till en mobil enhet med kamera- och GPS-funktion. GPS-funktionen låter dig hitta till de 54 förbestämda ”fotoplatser” i Stockholm, där du uppmanas använda kameran i din mobila enhet för att ta och ladda upp en bild. Genom att aktivera GPS-funktionen på din mobila enhet delar du enhetens platsinformation och denna information delas i och med att du laddar upp en bild.\n")]), _vm._v(" "), _c('h2', [_vm._v("Tävlingen")]), _vm._v(" "), _c('p', [_vm._v("\nExhibition Stockholm pågår 29 juni - 4 augusti. Alla över 18 år kan delta i tävlingen genom att via sin telefon besöka www.exhibitionstockholm.se och registrera sig med sitt Facebook-konto. Tävlingen bygger på att deltagaren använder webbapplikationens grafik för att hitta och fota ett antal utvalda platser i Stockholm. Sammanlagt finns 54 platser – så kallade ”fotoplatser” –fördelade på 11 geografiska områden – så kallade ”fotoområden”. Deltagare får poäng genom att:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("De tio deltagare som för tillfället har högst antal samlade poäng visas i en ”ranking-lista” i webbapplikationen. Deltagaren med flest poäng vid tävlingens slut vinner tävlingen och 30 000 SEK i prispengar. 2-10 pristagarna vinner en årsprenumeration på Creative Cloud fotografi, värd 1433 SEK. De 54 bilder med högst poäng på varje fotoplats ställs ut i en augmented reality-utställning i Kungsträdgården, 21- 27 augusti. Inget av priserna kan bytas ut mot pengar eller annat. Samtliga vinnare notifieras via e-post.")]), _vm._v(" "), _c('h2', [_vm._v("Bildrättigheter")]), _vm._v(" "), _c('p', [_vm._v("\nAdobe gör inte anspråk på full äganderätt till dina bilder. Som beskrivs vidare längre ner i avsnitt 3, behåller du äganderätt till ditt innehåll men genom att tillgängliggöra bilder genom Exhibition Stockholm ger du Adobe och andra företag inom Adobe-gruppen, en heltäckande licens att använda bildmaterialet för att administrera och marknadsföra tävlingen, isolerat eller i anslutning till Adobes produkter och tjänster (se 3.2.)  ")]), _vm._v(" "), _c('h2', [_vm._v("Övrig spridning")]), _vm._v(" "), _c('p', [_vm._v("\nFör de bilder du tar i Exhibition Stockholm men som du även laddar upp på social medieplattform så gäller det valda mediets/plattformens villkor, exempelvis för Facebook gäller Facebooks rättigheter och användarvillkor och för Snapchat gäller Snapchats rättigheter och användarvillkor.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("1. Deltagande")]), _vm._v(" "), _c('h3', [_vm._v("1.1 Kvalificeringskrav")]), _vm._v(" "), _c('p', [_vm._v("\nDu har endast rätt att använda Exhibition Stockholm och delta i tävlingen om du är över 18 år och bosatt i Sverige. Varje enskild deltagare har bara rätt att delta en gång och kan bara vinna ett pris. \n")]), _vm._v(" "), _c('h3', [_vm._v("1.2 Integritet")]), _vm._v(" "), _c('p', [_vm._v(" \nFör att delta måste du logga in via Facebook och lämna viss personlig information till Adobe – namn, efternamn och Facebook-inloggningsuppgifter. Vi samlar in dessa uppgifter för att administrera tävlingen Exhibition Stockholm och för att kontakta samt offentliggöra vinnare. På begäran från Adobe kan du behöva lämna ditt personnummer, för att vi ska kunna fullgöra skyldigheter gentemot skattemyndigheterna för det fallet att du vinner ett pris. Personuppgiftsansvarig är Adobe Systems Incorporated, 345 Park Avenue, San Jose, CA 95110-2704, Tel: 408-536-6000 (http://www.adobe.com/se/about-adobe/contact.html). Tillämplig integritetslagstiftning tillämpas och du har enligt lag rätt att få information om vilka uppgifter om dig vi sparar om dig, samt att få felaktiga uppgifter rättade. Kontakta oss om du har frågor eller önskemål härvid. \n")]), _c('p', [_vm._v("\nIntegritetspolicyn på http://www.adobe.com/privacy.html reglerar i övrigt all personlig information som du lämnar till oss. \nGenom att använda Exhibition Stockholm godkänner du ovan villkor och integritetspolicyn.\n")]), _vm._v(" "), _c('h3', [_vm._v("1.3 Tillgänglighet")]), _vm._v(" "), _c('p', [_vm._v("\nDu ansvarar som deltagare själv för egen utrustning, såsom dator, smartphone eller kamerautrustning samt mjukvara och dess kompatibilitet med Webbapplikationen. Webbapplikationen Exhibition Stockholm är tillgänglig i hela världen, men detta innebär inte att webbapplikationen fungerar i alla länder, eller att det användargenererade innehållet som tillgängliggörs via tjänsterna är lagligt i alla länder. Det är på eget ansvar att se till att användning av Exhibition är lagligt i landet du befinner dig i.")]), _vm._v(" "), _c('h2', [_vm._v("2. Användning av webbapplikationen")]), _vm._v(" "), _c('h3', [_vm._v("2.1 Åtkomst")]), _vm._v(" "), _c('p', [_vm._v("\nUnder förutsättning att du efterlever dessa villkor och tillämplig lagstiftning har du rätt att komma åt och använda Exhibition Stockholm. \n")]), _vm._v(" "), _c('h3', [_vm._v("2.2 Användarinnehåll")]), _vm._v(" "), _c('p', [_vm._v("\nAnvändare av Exhibition Stockholm går med på att inte ladda upp innehåll i Exhibition Stockholm som inte följer tävlingsreglerna, vilket inkluderar uppladdning av foton och annat innehåll enligt avsnitt 5.2 g samt foton som inte är tagna på de utsatta fotoområdena i tävlingen. Genom att ansluta till Exhibition Stockholm och vid deltagande i tävlingen bekräftar du din förståelse av och intygar att du kommer att avstå från att ladda upp bildmaterial som kan verka stötande eller annars olämpligt, inkluderat framställning som innehåller eller anspelar på våld, brottsligt eller klandervärt agerande, pornografiskt eller sexistisk tema, alkohol, droger, rasism, religion, diskriminering, nedvärderande av person eller grupp, eller material som på annat sätt innefattar oetisk skildring.\n")]), _vm._v(" "), _c('h3', [_vm._v("2.3 Förfoganderätt till ditt eget innehåll")]), _vm._v(" "), _c('p', [_vm._v("\nGenom att ansluta till Exhibition Stockholm och vid deltagande i tävlingen bekräftar du din förståelse av och intygar också att det är du själv som har skapat och komponerat det bildmaterial du laddar upp och att du således är att betrakta som upphovsman i förhållande till materialet. Du intygar därutöver att din bild inte är ett plagiat och att du inte i din bild i strid med tredjepartsrättigheter exponerar element för vilket immateriell rättighet tillhör tredje part, inkluderat varumärke, upphovsrätt, design- och mönsterskydd etc., samt att ingen identifierbar person som syns i bilden motsäger sig medverkan, innefattat den exponering av bilden som användande Exhibition Stockholm samt deltagande i tävlingen medför.")]), _vm._v(" "), _c('h3', [_vm._v("2.4 Otillåtet material")]), _vm._v(" "), _c('p', [_vm._v("Adobe förbehåller sig rätten att radera bildmaterial och allt innehåll som bryter eller kan antas bryta mot dessa villkor. Användare kan genom knappen ”Rapportera” rapportera olämpligt innehåll till Adobe. En sådan rapport medför dock ej skyldighet för Adobe att agera.\n")]), _vm._v(" "), _c('h2', [_vm._v("3. Innehåll och äganderätt")]), _vm._v(" "), _c('h3', [_vm._v("3.1 Originalfoton")]), _vm._v(" "), _c('p', [_vm._v(" \nSamtliga foton i Exhibition Stockholm måste vara originalfoton fotade av deltagarna. Fotona får tidigare inte ha använts i någon typ av tävling, utställning, marknadsföring, PR eller liknande privat eller kommersiellt sammanhang. \n")]), _vm._v(" "), _c('h3', [_vm._v("3.2 Upphovsrätt")]), _vm._v(" "), _c('p', [_vm._v("Genom att tillgängliggöra bilder genom Exhibition Stockholm ger du Adobe och andra företag inom Adobe-gruppen, en icke-exklusiv, global, i tiden obegränsad, kostnads- och royaltyfri, oåterkallelig licens att använda, bearbeta, framställa exemplar av, visa och publicera bildmaterialet för att administrera och marknadsföra tävlingen, isolerat eller i anslutning till Adobes produkter och tjänster, oavsett medium, inkluderat  rätt att publicera vinnande bilder i samband med information om och marknadsföring av Exhibition Stockholm, både i elektronisk och tryckt form.\n")]), _vm._v(" "), _c('h3', [_vm._v("3.3 Vår åtkomst")]), _vm._v(" "), _c('p', [_vm._v("\nVi öppnar, visar eller lyssnar på ditt innehåll endast på begränsade sätt. För att kunna genomföra Exhibition Stockholm kan vi exempelvis behöva öppna, visa eller lyssna på ditt innehåll i syfte att (a) svara på supportförfrågningar, (b) upptäcka, förhindra eller på annat sätt ta itu med fusk, säkerhetsfrågor, lagöverträdelser eller tekniska problem, samt (c) upprätthålla dessa villkor. \n")]), _vm._v(" "), _c('h3', [_vm._v("3.4 Delning av ditt innehåll")]), _vm._v(" "), _c('p', [_vm._v("(a) Delning. Genom Exhibition Stockholm publicerar användare sitt innehåll offentligt och delar därmed innehållet med andra användare. Med ”dela” avses e-posta, publicera, överföra, ladda upp eller på annat sätt göra sitt innehåll tillgängligt (för oss eller för andra användare). Andra användare kan använda, kopiera, modifiera eller dela med sig av ditt innehåll på många sätt. Genom ditt deltagande bekräftar du din förståelse av att Adobe inte kan kontrollera eller ansvarar för enskilda användares agerande eller bruk av ditt publika material.")]), _c('p', [_vm._v("\n(b) Andras åtkomst. Vi bevakar eller kontrollerar inte vad andra gör med ditt innehåll. Adobe saknar möjlighet att styra interaktion mellan enskilda användare.")]), _c('p', [_vm._v("\n(c) Kommentarer. Tjänsterna kan omfatta funktioner för att kommentera innehåll. Kommentarerna är inte anonyma och kan ses av andra användare. Dina kommentarer kan tas bort av dig, av andra användare eller av oss. När du skriver kommentarer tillämpas på motsvarande sätt förhållningsreglerna för innehåll såsom de föreskrivs i ovan artikel 2.2-2.4, \n")]), _vm._v(" "), _c('h2', [_vm._v("4. Kontoinformation")]), _vm._v(" "), _c('p', [_vm._v("Du ansvarar för all aktivitet som sker via ditt konto på Exhibition Stockholm och att endast du själv använder det. Kontakta oss omedelbart om du upptäcker obehörig användning av ditt konto.")]), _vm._v(" "), _c('h2', [_vm._v("5. Användarens uppträdande")]), _vm._v(" "), _c('p', [_vm._v("5.1 Ansvarig användning. Adobe-grupperna består ofta av användare som förväntar sig en viss nivå av artighet och professionalism. Du måste använda tjänsterna på ett ansvarsfullt sätt.\n")]), _c('p', [_vm._v("5.2 Missbruk. Du får inte missbruka den programvara eller det innehåll som vi tillhandahåller som en del av Exhibition Stockholm. Exempelvis får du inte:")]), _vm._v(" "), _c('p', [_vm._v("(a) kopiera, modifiera, vara värd för, spela upp, vidarelicensiera eller sälja vidare programvaran eller innehållet;\n")]), _c('p', [_vm._v("(b) göra det möjligt för eller tillåta andra att använda programvaran eller innehållet med hjälp av dina kontouppgifter;\n")]), _c('p', [_vm._v("(c) använda innehåll eller programvara som ingår i Exhibition Stockholm för att skapa någon slags databas;\n")]), _c('p', [_vm._v("(d) komma åt eller försöka komma åt Exhibition Stockholm via andra medel än det gränssnitt som vi tillhandahållit eller godkänt;\n")]), _c('p', [_vm._v("(e) kringgå eventuella begränsningar av tillgången till eller användningen av Exhibition Stockholm som införts för att förhindra viss användning av Exhibition Stockholm;\n")]), _c('p', [_vm._v("(f) dela innehållet eller vidta åtgärder som bryter mot någon parts immateriella rättigheter (”immateriella rättigheter” avser upphovsrätt, moraliska rättigheter, varumärke, produktdesign, patent, företagshemligheter, illojal konkurrens, rätt till integritet, publicitetsrätt och eventuella andra immateriella rättigheter);\n")]), _c('p', [_vm._v("(g) ladda upp eller dela med dig av innehåll som är olagligt, skadligt, hotfullt, otillbörligt, skadeståndsgrundande, ärekränkande, skymfligt, vulgärt, osedligt eller vanvördigt eller innehåll som gör intrång i någon annans privatliv eller sprider hat;\n")]), _c('p', [_vm._v("(h) utge dig för att vara någon annan person eller organisation eller uppge felaktiga uppgifter om eller på annat sätt ge en missvisande bild av din koppling till en person eller organisation;\n")]), _c('p', [_vm._v("(i) försöka stänga ned, skada eller förstöra Exhibition Stockholm, programvaran.\n")]), _c('p', [_vm._v("(j) avbryta, störa eller hindra andra användare från att använda Exhibition Stockholm (t.ex. genom att förfölja, hota eller trakassera andra, uppmuntra andra till våld eller skada minderåriga på något sätt);\n")]), _c('p', [_vm._v("(k) ägna dig åt kedjebrev, skräppost, pyramidspel, spam eller andra oönskade meddelanden;\n")]), _c('p', [_vm._v("(l) annonsera ut varor eller tjänster inom ramen för Exhibition Stockholm, förutom med föregående skriftligt tillstånd från oss;\n")]), _c('p', [_vm._v("(m) använda dig av någon metod för datautvinning eller liknande insamling eller extrahering av data i samband med Exhibition Stockholm;\n")]), _c('p', [_vm._v("(n) bryta mot gällande lag")]), _vm._v(" "), _c('h2', [_vm._v("6. Garantier.")]), _vm._v(" "), _c('p', [_vm._v("6.1 Exhibition Stockholm tillhandahålls ”i befintligt skick”. Du ges inga garantier, uttryckliga eller underförstådda, inklusive underförstådda garantier avseende icke-intrång, säljbarhet och lämplighet för ett särskilt ändamål, gällande webbapplikationen, dess funktion eller innehåll. Vi gör heller inga åtaganden gällande innehållet inom Exhibition Stockholm eller tävlingen i övrigt. Inga garantier ges om att (a) Exhibition Stockholm uppfyller dina krav, alltid kommer att vara tillgänglig utan avbrott, levereras punktligt och vara säker och felfri(b) resultaten som kan erhållas från användning av Exhibition Stockholm kommer att vara effektiva, korrekta eller tillförlitliga, (c) Exhibition Stockholm kvalitet kommer att uppfylla dina förväntningar, eller att (d) eventuella fel eller defekter i Exhibition Stockholm kommer att korrigeras.")]), _vm._v(" "), _c('p', [_vm._v("6.2 Du ansvarar själv för åtgärder som vidtas till följd av din användning av Exhibition Stockholm. Du bereder dig tillgång till och använder Exhibition Stockholm efter eget gottfinnande och på egen risk och du är ensamt ansvarig för eventuella skador på din dator eller mobiltelefon och förlust av data som orsakas av användningen av Exhibition Stockholm.\n")]), _vm._v(" "), _c('h2', [_vm._v("7. Ansvarsbegränsning")]), _vm._v(" "), _c('p', [_vm._v("7.1 Adobe ansvarar inte, inför dig eller någon annan, för (a) förlust av användning, goodwill, data eller vinst, oavsett om förlusten kunde förutses eller ej, och inte heller (b) för några särskilda, oavsiktliga, indirekta skador, följdskador eller straffbara skador (även om vi har underrättats om risken för dessa skador) och inte heller för sådana skador som uppstår på grund av förlust av data eller vinst, oavsett om de varit förutsägbara, baserats på teori om ansvar, inklusive kontrakts- eller garantibrott, försumlighet eller andra skadliga handlingar eller andra krav som uppstår ur eller i samband med din användning av eller tillgång till Exhibition Stockholm. Ingenting i dessa villkor begränsar eller utesluter vårt ansvar för grov vårdslöshet, för vår (eller våra anställdas) avsiktliga försummelse, eller för dödsfall eller personskada.")]), _vm._v(" "), _c('h2', [_vm._v("8. Uppsägning")]), _vm._v(" "), _c('h3', [_vm._v("8.1 Uppsägning av dig")]), _vm._v(" "), _c('p', [_vm._v("Du kan upphöra med att använda Exhibition Stockholm när som helst. Du är dock medveten om och godkänner att redan uppladdat material därmed inte raderas per automatik och att Adobe inte kontrollerar länkning eller spridning genomförd av andra användare.\n")]), _vm._v(" "), _c('h3', [_vm._v("8.2 Uppsägning av oss")]), _vm._v(" "), _c('p', [_vm._v("Om vi säger upp dessa villkor av någon anledning kommer vi att göra rimliga ansträngningar att meddela dig detta, via den e-postadress du har gett oss. Adobe kan när som helst säga upp din rätt att använda och komma åt Exhibition Stockholm om:\n")]), _c('p', [_vm._v("(a) du bryter mot något av dessa villkor (eller agerar på ett sätt som tydligt visar att du inte har för avsikt att, eller inte kan, uppfylla dessa villkor);\n")]), _c('p', [_vm._v("(c) vi är skyldiga enligt lag att göra detta (t.ex. om det är eller blir olagligt att leverera programvaran till dig);\n")]), _c('p', [_vm._v("(d) vi väljer att upphöra med Exhibition Stockholm, helt eller delvis, (exempelvis om det blir opraktiskt för oss att fortsätta erbjuda Exhibition Stockholm);\n")]), _c('p', [_vm._v("(e) en längre tid har gått utan någon aktivitet på ditt konto.")]), _vm._v(" "), _c('h2', [_vm._v("9. Undersökningar")]), _vm._v(" "), _c('h3', [_vm._v("9.1 Screening")]), _vm._v(" "), _c('p', [_vm._v("Vi granskar inte allt innehåll som laddas upp till Exhibition Stockholm, men vi kan använda tillgänglig teknik eller processer för att screena för vissa typer av olagligt innehåll (exempelvis barnpornografi) eller annat otillbörligt innehåll eller beteende (exempelvis aktivitetsmönster som indikerar spam eller phishing eller sökord som indikerar pornografiskt innehåll som har lagts upp utanför området för vuxeninnehåll).")]), _vm._v(" "), _c('h3', [_vm._v("9.2 Utlämnande")]), _vm._v(" "), _c('p', [_vm._v("Vi kan ta del av eller lämna ut information om dig eller din användning av Exhibition Stockholm (a) när det krävs enligt lag (t.ex. vid giltig stämning eller husrannsakningsorder) (b) för att kunna ge dig support för Exhibition Stockholm eller (c) när vi, efter eget gottfinnande, anser att det är nödvändigt för att skydda våra, våra användares eller allmänhetens rättigheter, egendom eller personliga säkerhet.")]), _vm._v(" "), _c('h2', [_vm._v("10. Tvistlösning")]), _vm._v(" "), _c('h3', [_vm._v("10.1 Process")]), _vm._v(" "), _c('p', [_vm._v("Du samtycker till att i första hand försöka lösa eventuella tvister informellt genom att kontakta Adobe gällande alla eventuella problem eller tveksamheter.")]), _vm._v(" "), _c('h3', [_vm._v("11. Ändring")]), _vm._v(" "), _c('p', [_vm._v("Vi kan ändra dessa villkor eller eventuella ytterligare villkor som gäller för Exhibition Stockholm, till exempel för att villkoren ska återspegla en lagändring eller ändringar i Exhibition Stockholm. Du bör titta på villkoren regelbundet. Vi kommer att publicera meddelanden om ändringar i dessa villkor på denna sida. Genom att fortsätta att använda eller öppna Exhibition Stockholm efter det att ändringarna har trätt i kraft godkänner du de ändrade villkoren.")]), _vm._v(" "), _c('h3', [_vm._v("12. Tävlingspris")]), _vm._v(" "), _c('p', [_vm._v("12. 1 Deltagaren med flest poäng i Exhibition Stockholm vinner tävlingen och 30 000 SEK i prispengar. 2-10 pristagarna vinner en årsprenumeration på Creative Cloud fotografi, värd  1433 SEK. De 54 bilder med högst poäng på varje fotoplats ställs ut i en augmented reality-utställning i Kungsträdgården, den 21- 27 augusti. Inget av priserna kan bytas ut mot pengar eller annat.\n")]), _c('p', [_vm._v("12. 2 Vinnarna i Exhibition Stockholm ansvarar för att betala eventuell vinstskatt eller andra lokala avgifter i förhållande till tävlingspriserna.")]), _vm._v(" "), _c('h2', [_vm._v("13. Övrigt")]), _vm._v(" "), _c('p', [_vm._v("13.1 Meddelande till Adobe. Du kan skicka meddelanden till oss på följande adress: Adobe Systems Incorporated, 345 Park Avenue, San Jose, California 951102704, att.: General Counsel.\n")]), _c('p', [_vm._v("13.2 Meddelande till dig. Vi kan komma att meddela dig via e-post, vanlig post, publicering inom Exhibition Stockholm, eller på annat sätt.\n")]), _c('p', [_vm._v("13.3 Hela avtalet. Dessa villkor utgör hela avtalet mellan dig och oss när det gäller din användning av Exhibition Stockholm och deltagande i tävlingen.\n")]), _c('p', [_vm._v("13.4 Ej överlåtbar rätt. Du får inte, vare sig helt eller delvis, tilldela eller på annat sätt överföra dessa villkor eller dina rättigheter och skyldigheter enligt villkoren utan vårt skriftliga godkännande, och varje sådant försök till överförande är ogiltigt. Vi får överföra våra rättigheter enligt dessa villkor till tredje part.\n")]), _c('p', [_vm._v("13.5 Separeringsklausul. Om ett visst villkor inte är verkställbart påverkar detta villkors ogiltighet inte de andra villkoren.\n")]), _c('p', [_vm._v("13.6 Ingen avsägelse. Om vi misslyckas med att verkställa eller utöva något av dessa villkor utgör det inte en avsägelse av avsnittet ifråga.")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("Hitta en fotoplats (10 poäng)")]), _vm._v(" "), _c('li', [_vm._v("Ta en bild på fotoplatsen (20 poäng)")]), _vm._v(" "), _c('li', [_vm._v("Få röster på sin bild (Antalet poäng är föränderligt och styrs procentuellt baserat på andelen positiva röster i förhållande till samtliga röster; exempelvis ger sju positiva av totalt tio röster 70 poäng. Användaren måste ha fått minst fem röster på sin bild för att få sina första röstbaserade poäng.)")])])
}]}

/***/ }),
/* 116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "infoMenu"
  }, [(_vm.bugReport) ? _c('modal', [_c('div', {
    slot: "header"
  }, [_vm._v("Beskriv en bugg eller din synpunkt nedan.")]), _vm._v(" "), _c('div', {
    slot: "body"
  }, [_c('textarea', {
    attrs: {
      "id": "bugreport-text"
    }
  })]), _vm._v(" "), _c('div', {
    slot: "footer"
  }, [_c('div', {
    staticClass: "modal-button",
    on: {
      "click": function($event) {
        _vm.$store.commit('showBugReport', false)
      }
    }
  }, [_vm._v("Avbryt")]), _vm._v(" "), _c('div', {
    staticClass: "modal-button",
    on: {
      "click": _vm.reportABug
    }
  }, [_vm._v("Skicka")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "inside-closer",
    on: {
      "click": function($event) {
        _vm.$store.commit('showInfoMenu', false)
      }
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "menu-header"
  }, [_vm._v("General")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "list-item",
    on: {
      "click": function($event) {
        _vm.$store.commit('showBugReport', true)
      }
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Hör av dig")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Skicka en bugg eller andra synpunkter på spelet!")])]), _vm._v(" "), _vm._l((_vm.list), function(listItem) {
    return _c('div', {
      staticClass: "list-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(listItem.title))]), _vm._v(" "), _c('div', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(listItem.subtitle))])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "list-item",
    attrs: {
      "href": "https://game.exhibitionstockholm.se"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Start")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Gå till startsidan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "list-item",
    attrs: {
      "href": "https://game.exhibitionstockholm.se/#/tutorial"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Guide")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Gå till startguiden")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "list-item",
    attrs: {
      "href": "https://helpx.adobe.com/lightroom/how-to/lightroom-mobile.html",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Lightroom Mobile")]), _vm._v(" "), _c('div', {
    staticClass: "subtitle"
  }, [_vm._v("Kom igång med Lightroom Mobile")])])
}]}

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    staticClass: "interupt",
    attrs: {
      "id": "interupt"
    }
  }, [(_vm.type === 'regular') ? _c('div', {
    staticClass: "interupt-regular"
  }, [_c('div', {
    staticClass: "back"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun"
  }, [_c('div', {
    staticClass: "fun-item fun-sun hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-camera bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-key bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-squares hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crop bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-levers hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crown bigEntrance"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, [_c('div', {
    staticClass: "cell-content"
  }, [_c('div', {
    staticClass: "the-text",
    domProps: {
      "innerHTML": _vm._s(_vm.interupt)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-butt",
    on: {
      "click": function($event) {
        _vm.$store.commit('interupt', null)
      }
    }
  }, [_vm._v("Ok")])])])]) : _vm._e(), _vm._v(" "), (_vm.type === 'win') ? _c('div', {
    staticClass: "interupt-win"
  }, [_c('div', {
    staticClass: "back"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun"
  }, [_c('div', {
    staticClass: "fun-item fun-sun hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-happy-green bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crop bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-levers hatch"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-crown bigEntrance"
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-item fun-happy-yellow bigEntrance"
  })]), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, [_c('div', {
    staticClass: "cell-content"
  }, [_c('div', {
    staticClass: "the-text",
    domProps: {
      "innerHTML": _vm._s(_vm.interupt)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fun-butt",
    on: {
      "click": function($event) {
        _vm.$store.commit('interupt', null)
      }
    }
  }, [_vm._v("Ok")])])])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "interupt",
    attrs: {
      "id": "interupt"
    }
  }, [_c('div', {
    staticClass: "back"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, [_c('div', {
    staticClass: "cell-content"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(86),
      "width": "44"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-20"
  }), _vm._v("\n      För att delta i tävlingen måste spelet använda din enhets platsinformation"), _c('br'), _vm._v(" "), _c('h6', [_c('u', {
    on: {
      "click": _vm.openTurnOn
    }
  }, [_vm._v("Läs steg för steg instruktioner för iOS och Android här!")]), _c('br'), _c('br'), _c('u', {
    on: {
      "click": _vm.laddaOmSida
    }
  }, [_vm._v("Ladda om sidan")]), _c('br'), _c('br')])])])])
},staticRenderFns: []}

/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view view-ar"
  }, [(_vm.showingPhotoId !== null) ? _c('single-feed', {
    attrs: {
      "photoid": _vm.showingPhotoId
    },
    on: {
      "close": function($event) {
        _vm.showingPhotoId = null
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "fixed",
      "top": "0px",
      "left": "0px",
      "z-index": "999",
      "width": "100%"
    }
  }, [(_vm.infotext !== '') ? _c('infobox', {
    attrs: {
      "text": _vm.infotext
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "ar"
  }, [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "argon"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "argon-canvas"
    },
    on: {
      "click": _vm.clickHandler
    }
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "camera",
    attrs: {
      "id": "camera"
    }
  }, [_c('video', {
    attrs: {
      "id": "camera-video",
      "autoplay": ""
    }
  })])
}]}

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open === false),
      expression: "open === false"
    }],
    staticClass: "float-menu"
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": function($event) {
        _vm.$store.commit('changeShowMenu', false)
      }
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "outside"
  }, [(_vm.user !== null) ? _c('div', {
    staticClass: "info-button",
    on: {
      "click": function($event) {
        _vm.$store.commit('showInfoMenu', true)
      }
    }
  }, [_vm._v(" ☰")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "menu-battle float-item",
    attrs: {
      "to": "/votev"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_vm._v("Rösta")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-profile float-item",
    attrs: {
      "to": "/profile"
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_vm._v("Profil")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-ar float-item",
    attrs: {
      "to": "/ar"
    },
    nativeOn: {
      "click": function($event) {
        _vm.closeMenu($event)
      }
    }
  }, [_c('div', {
    staticClass: "info-text"
  }, [_vm._v("Glasögon")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box",
    on: {
      "click": _vm.toggleBubble
    }
  }, [_c('div', {
    staticClass: "circle"
  }, [_vm._v("\n    i\n  ")]), _vm._v(" "), (_vm.isOpen === true && true === false) ? _c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-side"
  }, [_c('div', {
    staticClass: "top"
  }), _vm._v(" "), _c('div', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  })])
}]}

/***/ }),
/* 122 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    attrs: {
      "id": "spot"
    }
  }, [(_vm.browsing === false) ? _c('div', {
    staticClass: "content",
    attrs: {
      "id": "choose"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Fotoplats")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "blue-circle"
  }), _vm._v(" " + _vm._s(_vm.atSpot[0]))]), _vm._v(" "), (_vm.atSpotWinner !== null) ? _c('div', {
    staticClass: "spot-winner padding-20 eye",
    style: ({
      backgroundImage: 'url(' + _vm.atSpotWinner.thumburl + ')'
    }),
    on: {
      "click": function($event) {
        _vm.$store.dispatch('viewSinglePhoto', _vm.atSpotWinner)
      }
    }
  }) : _c('div', {
    staticClass: "spot-winner padding-20"
  }, [_c('br'), _c('br'), _c('br'), _vm._v("Inget foto visas än, bli först!")]), _vm._v(" "), (_vm.atSpotWinner) ? _c('div', {
    staticClass: "sub-heading-list"
  }, [_c('div', {
    staticClass: "sub-heading"
  }, [_vm._v("Fotograf")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.atSpotWinner.username))]), _vm._v(" "), _c('div', {
    staticClass: "border"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [(_vm.userHasPhotoAtSpot === false) ? _c('a', {
    staticClass: "upload-button blue-butt",
    on: {
      "click": _vm.challangePhoto
    }
  }, [_vm._v("Ladda upp ditt bidrag")]) : _c('a', {
    staticClass: "upload-button blue-butt",
    on: {
      "click": _vm.challangePhoto
    }
  }, [_vm._v("Byt ut ditt foto")]), _vm._v(" "), _c('a', {
    staticClass: "black-on-white-butt browse",
    on: {
      "click": _vm.browsePhotos
    }
  }, [_vm._v("Se foton från platsen")])]), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })]) : _c('div', {
    staticClass: "content",
    attrs: {
      "id": "browse"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-20"
  }, [_vm._v("Fotoplats")]), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_c('div', {
    staticClass: "blue-circle"
  }), _vm._v(" " + _vm._s(_vm.atSpot[0]))]), _vm._v(" "), _c('div', {
    staticClass: "sub-heading padding-40 pad-sides"
  }, [_vm._v("\n      Foton på platsen\n    ")]), _vm._v(" "), (_vm.atSpotPhotosLoaded === true) ? _c('div', {
    staticStyle: {
      "padding": "15px 0px"
    }
  }, [_c('photoFeed', {
    attrs: {
      "photos": _vm.atSpotPhotos,
      "show-user": "true",
      "show-spot": "false"
    }
  }, [_c('div', {
    slot: "empty"
  }, [_vm._v("No photos at spot.")])])], 1) : _c('div', [_c('loader', {
    attrs: {
      "colorClass": "black"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])])
},staticRenderFns: []}

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'spinner ' + _vm.colorClass
  })
},staticRenderFns: []}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view",
    attrs: {
      "id": "photoUpload"
    }
  }, [_c('div', {
    staticClass: "inside-closer",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("✖")]), _vm._v(" "), (_vm.user === null) ? _c('div', {
    staticClass: "slide-container"
  }, [_c('div', {
    staticClass: "padding-80"
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(87),
      "width": "50"
    }
  }), _c('br'), _c('br'), _vm._v("\n    Du måste vara inloggad för att bidra!\n    "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('router-link', {
    staticClass: "black-on-white-butt",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("Logga in eller skapa ett konto")])], 1) : _vm._e(), _vm._v(" "), (_vm.user !== null) ? _c('div', {
    staticClass: "slide-container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'register'),
      expression: "view === 'register'"
    }]
  }, [_vm._v("\n      Registrera dig för att ladda upp.\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'addemail'),
      expression: "view === 'addemail'"
    }]
  }, [_vm._v("\n      Registrera dig för att ladda upp.\n    ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'upload'),
      expression: "view === 'upload'"
    }],
    staticClass: "slide-view"
  }, [_c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "upload-icon"
  }), _vm._v(" "), (_vm.userOS === 'ios') ? _c('div', {
    staticClass: "black-on-white-butt margin-40",
    on: {
      "click": _vm.openInIos
    }
  }, [_vm._v("1. Fota med Lightroom")]) : _vm._e(), _vm._v(" "), (_vm.userOS === 'android') ? _c('a', {
    staticClass: "black-on-white-butt margin-40",
    attrs: {
      "href": "https://play.google.com/store/apps/details?id=com.adobe.lrmobile",
      "target": "_blank"
    },
    on: {
      "click": _vm.openInGoogle
    }
  }, [_vm._v("1. Fota med Lightroom")]) : _vm._e(), _vm._v(" "), (_vm.userOS === false) ? _c('a', {
    staticClass: "black-on-white-butt margin-40",
    attrs: {
      "href": "https://lightroom.adobe.com/",
      "target": "_blank"
    }
  }, [_vm._v("1. Fota med Lightroom")]) : _vm._e(), _vm._v(" "), _c('label', {
    staticClass: "upload-file-label"
  }, [_c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "id": "fileupload-input",
      "name": "fileupload",
      "accept": "image/*"
    },
    on: {
      "change": _vm.selectFile
    }
  }), _vm._v(" "), (_vm.isSaving) ? _c('span', [_vm._m(0)]) : _c('span', [_c('div', {
    staticClass: "blue-butt margin-20"
  }, [_vm._v("2. Ladda upp foto")])])]), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "body-white"
  }, [_c('div', {
    staticClass: "body-heading"
  }, [_vm._v("Tips: " + _vm._s(_vm.tip.title))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.tip.body)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "padding-40"
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.view === 'confirm'),
      expression: "view === 'confirm'"
    }],
    staticClass: "confirm-upload"
  }, [_c('canvas', {
    attrs: {
      "id": "thumb-canvas"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "preview-image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "body-white padding-40"
  }, [_vm._v("\n        Användare i spelet bestämmer hur bra fotot är. I röstningen väljer man om man tycker ett foto är bra eller mindre bra.\n      ")]), _vm._v(" "), (_vm.uploading === false) ? _c('div', [_c('div', {
    staticClass: "blue-butt margin-40",
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("Skicka in foto")]), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })]) : _vm._e(), _vm._v(" "), (_vm.uploading === true) ? _c('div', [_c('div', {
    staticClass: "body-heading padding-40"
  }, [_vm._v("Laddar upp..." + _vm._s(_vm.uploadingPhotoProgress) + "%")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "padding-80"
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "body-heading margin-20"
  }, [_c('br'), _vm._v("Hämtar...")])
}]}

/***/ }),
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */
/***/ (function(module, exports) {

module.exports = {
	"features": [
		{
			"type": "Feature",
			"properties": {
				"key": "danderyd",
				"name": "Danderyd"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.022864,
							59.398759
						],
						[
							18.022693,
							59.396882
						],
						[
							18.028287,
							59.395887
						],
						[
							18.039254,
							59.397081
						],
						[
							18.038448,
							59.399841
						],
						[
							18.02792,
							59.400761
						],
						[
							18.022864,
							59.398759
						]
					]
				],
				"type": "Polygon"
			},
			"id": "187943ad8d88cdcd5ecbf734f17fd2de"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "sodero",
				"name": "Söder - öst"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.077083,
							59.313341
						],
						[
							18.077904,
							59.311665
						],
						[
							18.091932,
							59.309545
						],
						[
							18.093394,
							59.312163
						],
						[
							18.08706,
							59.313236
						],
						[
							18.077083,
							59.313341
						]
					]
				],
				"type": "Polygon"
			},
			"id": "1b865a55d9ecddaa99b529c7bf1712d9"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "vasastan",
				"name": "Norrmalm - Vasastan"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.03981,
							59.341146
						],
						[
							18.042929,
							59.33802
						],
						[
							18.056588,
							59.338322
						],
						[
							18.062073,
							59.339857
						],
						[
							18.061697,
							59.346603
						],
						[
							18.056642,
							59.350852
						],
						[
							18.04992,
							59.349838
						],
						[
							18.03981,
							59.341146
						]
					]
				],
				"type": "Polygon"
			},
			"id": "1de8de51ae7ab9f0fc72bc073821fabc"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "ostermalm",
				"name": "Östermalm"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.077836,
							59.340061
						],
						[
							18.070399,
							59.341626
						],
						[
							18.062762,
							59.336609
						],
						[
							18.064663,
							59.334057
						],
						[
							18.075202,
							59.334517
						],
						[
							18.077836,
							59.340061
						]
					]
				],
				"type": "Polygon"
			},
			"id": "25584c05433adebc133014a7961d6446"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "soder",
				"name": "Söder - söder"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.080625,
							59.309121
						],
						[
							18.071193,
							59.308037
						],
						[
							18.070725,
							59.302873
						],
						[
							18.076989,
							59.302193
						],
						[
							18.082893,
							59.302597
						],
						[
							18.080625,
							59.309121
						]
					]
				],
				"type": "Polygon"
			},
			"id": "37124c21bdaa7abf7a3365c468222f19"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "sodernv",
				"name": "Söder - nordväst"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.049172,
							59.32121
						],
						[
							18.049778,
							59.318901
						],
						[
							18.056978,
							59.318801
						],
						[
							18.067564,
							59.320283
						],
						[
							18.066245,
							59.321401
						],
						[
							18.049172,
							59.32121
						]
					]
				],
				"type": "Polygon"
			},
			"id": "420599e24c58d39e2aaf904a0fe7c00e"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "djurgarden",
				"name": "Skeppshomen - Djurgården"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.077241,
							59.326598
						],
						[
							18.089999,
							59.332233
						],
						[
							18.100908,
							59.33221
						],
						[
							18.103682,
							59.320561
						],
						[
							18.088474,
							59.321103
						],
						[
							18.077241,
							59.326598
						]
					]
				],
				"type": "Polygon"
			},
			"id": "7239fd411cd000383604d52972007db7"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "hornstull",
				"name": "Hornstull"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.036092,
							59.320034
						],
						[
							18.025048,
							59.319213
						],
						[
							18.024526,
							59.315485
						],
						[
							18.039006,
							59.309693
						],
						[
							18.05479,
							59.312356
						],
						[
							18.051007,
							59.315263
						],
						[
							18.037484,
							59.315596
						],
						[
							18.036092,
							59.320034
						]
					]
				],
				"type": "Polygon"
			},
			"id": "8474a0c47e873e198f2a41a9002afac9"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "vkungsholmen",
				"name": "Västra Kungsholmen"
			},
			"geometry": {
				"coordinates": [
					[
						[
							17.996021,
							59.330818
						],
						[
							17.995507,
							59.336605
						],
						[
							18.006024,
							59.341327
						],
						[
							18.012992,
							59.341632
						],
						[
							18.022392,
							59.339472
						],
						[
							18.006656,
							59.328004
						],
						[
							17.996021,
							59.330818
						]
					]
				],
				"type": "Polygon"
			},
			"id": "91aff4c989fd8d2c95858cd682201953"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "frihamnen",
				"name": "Frihamnen"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.114475,
							59.343693
						],
						[
							18.11331,
							59.342161
						],
						[
							18.116561,
							59.340093
						],
						[
							18.121336,
							59.339301
						],
						[
							18.12775,
							59.340723
						],
						[
							18.12194,
							59.344265
						],
						[
							18.114475,
							59.343693
						]
					]
				],
				"type": "Polygon"
			},
			"id": "c5608dda66451177d002afa2357b0634"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "city",
				"name": "City"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.08147,
							59.332276
						],
						[
							18.076407,
							59.333312
						],
						[
							18.069997,
							59.33259
						],
						[
							18.068081,
							59.330973
						],
						[
							18.0658,
							59.329344
						],
						[
							18.067648,
							59.327727
						],
						[
							18.077273,
							59.327122
						],
						[
							18.080969,
							59.328728
						],
						[
							18.08147,
							59.332276
						]
					]
				],
				"type": "Polygon"
			},
			"id": "ca1e1eddc0fe95b35a689e91fd731fcd"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "langholmen",
				"name": "Långholmen - södra Kungsholmen"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.027748,
							59.329742
						],
						[
							18.022713,
							59.329921
						],
						[
							18.012408,
							59.320781
						],
						[
							18.016273,
							59.319048
						],
						[
							18.03052,
							59.319785
						],
						[
							18.03977,
							59.321279
						],
						[
							18.027748,
							59.329742
						]
					]
				],
				"type": "Polygon"
			},
			"id": "f09b4c88bfa1e45470e231b51d7d6a8e"
		},
		{
			"type": "Feature",
			"properties": {
				"key": "soderno",
				"name": "Söder - nordost"
			},
			"geometry": {
				"coordinates": [
					[
						[
							18.07488,
							59.32005
						],
						[
							18.071343,
							59.318119
						],
						[
							18.076612,
							59.314711
						],
						[
							18.089623,
							59.316389
						],
						[
							18.086135,
							59.318169
						],
						[
							18.07488,
							59.32005
						]
					]
				],
				"type": "Polygon"
			},
			"id": "fb66ca7d49edeb2adbf977bd6a3aaa3c"
		}
	],
	"type": "FeatureCollection"
};

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = [
	{
		"key": "soder",
		"name": "Söder - söder",
		"spots": [
			{
				"name": "Kön till Trädgården",
				"lat": "59.304636",
				"lng": "18.077207"
			},
			{
				"name": "Trädgård på Spåret",
				"lat": "59.305822",
				"lng": "18.073623"
			},
			{
				"name": "Nyfiken Gul",
				"lat": "59.303852",
				"lng": "18.072498"
			},
			{
				"name": "Skanstull",
				"lat": "59.307896",
				"lng": "18.076091"
			},
			{
				"name": "Skansbron",
				"lat": "59.303494",
				"lng": "18.080023"
			}
		]
	},
	{
		"key": "sodernv",
		"name": "Söder - nordväst",
		"spots": [
			{
				"name": "Skinnarviksberget",
				"lat": "59.319983",
				"lng": "18.050985"
			},
			{
				"name": "Ivar Los Park",
				"lat": "59.320529",
				"lng": "18.061199"
			},
			{
				"name": "Monteliusvägen",
				"lat": "59.320764",
				"lng": "18.060457"
			},
			{
				"name": "Bastugatan - Bellmansgatan",
				"lat": "59.320439",
				"lng": "18.064533"
			},
			{
				"name": "Lundabron",
				"lat": "59.319593",
				"lng": "18.056167"
			}
		]
	},
	{
		"key": "soderno",
		"name": "Söder - nordost",
		"spots": [
			{
				"name": "Mosebacketerrassen",
				"lat": "59.318338",
				"lng": "18.074950"
			},
			{
				"name": "Mosebacke Torg",
				"lat": "59.317986",
				"lng": "18.074446"
			},
			{
				"name": "Katarina Kyrka",
				"lat": "59.316616",
				"lng": "18.078325"
			},
			{
				"name": "Mäster Mikaels gata",
				"lat": "59.317392",
				"lng": "18.080702"
			},
			{
				"name": "Fjällgatan",
				"lat": "59.317364",
				"lng": "18.085878"
			}
		]
	},
	{
		"key": "sodero",
		"name": "Söder - öst",
		"spots": [
			{
				"name": "Nytorget",
				"lat": "59.312357",
				"lng": "18.083300"
			},
			{
				"name": "Sofia Kyrka",
				"lat": "59.312077",
				"lng": "18.088448"
			},
			{
				"name": "Vitabergsparken",
				"lat": "59.310911",
				"lng": "18.091259"
			},
			{
				"name": "Skånegatan",
				"lat": "59.312328",
				"lng": "18.079959"
			},
			{
				"name": "Bondegatan",
				"lat": "59.312903",
				"lng": "18.079133"
			}
		]
	},
	{
		"key": "city",
		"name": "City",
		"spots": [
			{
				"name": "Kungsträdgården",
				"lat": "59.331378",
				"lng": "18.071487"
			},
			{
				"name": "Gustav Adolfs Torg",
				"lat": "59.329496",
				"lng": "18.069230"
			},
			{
				"name": "Berzeeli Park - Nybroviken",
				"lat": "59.332087",
				"lng": "18.076268"
			},
			{
				"name": "Strömbron",
				"lat": "59.328907",
				"lng": "18.073167"
			},
			{
				"name": "Blasieholmen",
				"lat": "59.328921",
				"lng": "18.076812"
			}
		]
	},
	{
		"key": "ostermalm",
		"name": "Östermalm",
		"spots": [
			{
				"name": "Stureplan",
				"lat": "59.336070",
				"lng": "18.072758"
			},
			{
				"name": "Humlegården",
				"lat": "59.339389",
				"lng": "18.072775"
			},
			{
				"name": "Kungsgatan",
				"lat": "59.335884",
				"lng": "18.065550"
			},
			{
				"name": "Kungliga Biblioteket",
				"lat": "59.337805",
				"lng": "18.071762"
			},
			{
				"name": "Brunkebergstunneln",
				"lat": "59.337174",
				"lng": "18.066027"
			}
		]
	},
	{
		"key": "vasastan",
		"name": "Norrmalm - Vasastan",
		"spots": [
			{
				"name": "Observatorielunden",
				"lat": "59.341897",
				"lng": "18.055298"
			},
			{
				"name": "Vanadislunden",
				"lat": "59.348650",
				"lng": "18.054354"
			},
			{
				"name": "Vasaparken",
				"lat": "59.341027",
				"lng": "18.045870"
			},
			{
				"name": "Stockholms stadsbibliotek",
				"lat": "59.343486",
				"lng": "18.055384"
			},
			{
				"name": "Spökparken",
				"lat": "59.340258",
				"lng": "18.056281"
			}
		]
	},
	{
		"key": "langholmen",
		"name": "Långholmen - södra Kungsholmen",
		"spots": [
			{
				"name": "Långholmens klippbad",
				"lat": "59.322786",
				"lng": "18.034289"
			},
			{
				"name": "Långholmsklippan",
				"lat": "59.321709",
				"lng": "18.019313"
			},
			{
				"name": "Västerbron",
				"lat": "59.324184",
				"lng": "18.027669"
			},
			{
				"name": "Rålambshovsparken",
				"lat": "59.328623",
				"lng": "18.025893"
			}
		]
	},
	{
		"key": "vkungsholmen",
		"name": "Västra Kungsholmen",
		"spots": [
			{
				"name": "Solstugans Terrass",
				"lat": "59.331846",
				"lng": "17.997409"
			},
			{
				"name": "Kristinebergsklipporna",
				"lat": "59.335706",
				"lng": "17.996300"
			},
			{
				"name": "Fredhällsparken",
				"lat": "59.331484",
				"lng": "18.005949"
			},
			{
				"name": "Hornsbergs strandpark",
				"lat": "59.340745",
				"lng": "18.008243"
			},
			{
				"name": "Hornsbergs strandpromenad",
				"lat": "59.339735",
				"lng": "18.017271"
			}
		]
	},
	{
		"key": "djurgarden",
		"name": "Skeppsholmen - Djurgården",
		"spots": [
			{
				"name": "Djurgårdsbron",
				"lat": "59.331118",
				"lng": "18.093823"
			},
			{
				"name": "Skeppsholmsbron",
				"lat": "59.327271",
				"lng": "18.079182"
			},
			{
				"name": "Södra Brobänken",
				"lat": "59.323921",
				"lng": "18.086052"
			},
			{
				"name": "Kastellparken",
				"lat": "59.322215",
				"lng": "18.089466"
			},
			{
				"name": "Gamla Djurgården",
				"lat": "59.323503",
				"lng": "18.099146"
			}
		]
	},
	{
		"key": "hornstull",
		"name": "Hornstull",
		"spots": [
			{
				"name": "Lasse i Parken",
				"lat": "59.318739",
				"lng": "18.030820"
			},
			{
				"name": "Hornstulls Marknad",
				"lat": "59.315018",
				"lng": "18.030724"
			},
			{
				"name": "Bergsunds Strand",
				"lat": "59.316648",
				"lng": "18.026533"
			},
			{
				"name": "Hornviksstigen",
				"lat": "59.313515",
				"lng": "18.035811"
			},
			{
				"name": "Tantolunden",
				"lat": "59.313004",
				"lng": "18.049235"
			}
		]
	},
	{
		"key": "frihamnen",
		"name": "Frihamnen",
		"spots": [
			{
				"name": "AccompliceHQ",
				"lat": "59.343251",
				"lng": "18.115881"
			},
			{
				"name": "Auktionsverket",
				"lat": "59.341262",
				"lng": "18.124212"
			}
		]
	},
	{
		"key": "danderyd",
		"name": "Danderyd",
		"spots": [
			{
				"name": "Centrum",
				"lat": "59.397905",
				"lng": "18.036204"
			},
			{
				"name": "Golfbanan",
				"lat": "59.400198",
				"lng": "18.029808"
			}
		]
	}
];

/***/ }),
/* 130 */
/***/ (function(module, exports) {

module.exports = [
	{
		"image": "2XLuXlMT0Q1nPlzuVhpgGpbjI9wEFNPk1498936721-min.jpg",
		"username": "Martynas Justinevicius",
		"spot": "Solstugans Terrass"
	},
	{
		"image": "5g5HEFmQpgumRE9LhH9IirfCNLVCjXfB1499887943-min.jpg",
		"username": "Elin Strååt",
		"spot": "Skinnarviksberget"
	},
	{
		"image": "A2JHugzCRAXr5w6BAPT546MmYXLIxYVa1499961833-min.jpg",
		"username": "Josefin Bergman",
		"spot": "Brunkebergstunneln"
	},
	{
		"image": "afga1CSS0K3cqS8xk0uBLUPZfFzaQo781499004790-min.jpg",
		"username": "Johan Bjärnström",
		"spot": "Fjällgatan"
	},
	{
		"image": "bMfJcALHrvK44ngmmKSYjIOX6WK009OB1501659382-min.jpg",
		"username": "Fredrik Stene",
		"spot": "Kungliga Biblioteket"
	},
	{
		"image": "BGyTlEWfS1u2sY8RG8keVbED7MTNCiK61501532811-min.jpg",
		"username": "Anette Bothin",
		"spot": "Kungsgatan"
	},
	{
		"image": "DcezCfQaEQDXJ2u6T50fTOEM2devy2eS1500587198-min.jpg",
		"username": "Patrik Renström",
		"spot": "Västerbron"
	},
	{
		"image": "do2xr4BvhlUTn6TmtoB54vuC5Sl2AS901501744361-min.jpg",
		"username": "Olle Eriksson",
		"spot": "Bastugatan - Bellmansgatan"
	},
	{
		"image": "Gwr7vjNZq5BNMWTtCY7olHQNOAP0HHBG1500009940-min.jpg",
		"username": "Josefin Bergman",
		"spot": "Hornsbergs strandpark"
	},
	{
		"image": "KNtk4IrMva9gFkpcMsknmETc0lgrNEjA1499876690-min.jpg",
		"username": "Elin Strååt",
		"spot": "Bastugatan - Bellmansgatan"
	},
	{
		"image": "OIdodTT8zm43LNJKYX1h6I3psz2Su8Kz1501273716-min.jpg",
		"username": "Albin Per Hans Ulvebring",
		"spot": "Kastellparken"
	},
	{
		"image": "OZ6OfYSeLNPcAa8laAYqQnJle4U1kjOi1501743072-min.jpg",
		"username": "Olle Eriksson",
		"spot": "Skinnarviksberget"
	},
	{
		"image": "Q8ui7toOjfEDSkUa841szwchOTpf3EIO1501270954-min.jpg",
		"username": "Albin Per Hans Ulvebring",
		"spot": "Blasieholmen"
	},
	{
		"image": "rrOZKEuaskUem7ndr9LrrDYUbYTxr6Rt1499284033-min.jpg",
		"username": "Johan Bjärnström",
		"spot": "Berzeeli Park - Nybroviken"
	},
	{
		"image": "sAtE1weUEN3ql85YXbV8yzVJKl7dXxia1500575632-min.jpg",
		"username": "Patrik Renström",
		"spot": "Monteliusvägen"
	},
	{
		"image": "Syh5Bv1mgj2Jewj3ZRw31CG20Ov7wM3o1500565150-min.jpg",
		"username": "Olle Eriksson",
		"spot": "Kungliga Biblioteket"
	},
	{
		"image": "trSqDjgKv63FuhN4uTEjWyGMs2gPwAYE1499107981-min.jpg",
		"username": "Johan Bjärnström",
		"spot": "Trädgård på Spåret"
	},
	{
		"image": "vE8YoXYzQjOCaMrm9BWovUiTgD7xn7wW1501101870-min.jpg",
		"username": "Patrik Renström",
		"spot": "Södra Brobänken"
	},
	{
		"image": "wDMN4Z15VocSj5tBTVVQn9LB0wzxOr291501528306-min.jpg",
		"username": "Enna Pü",
		"spot": "Kastellparken"
	},
	{
		"image": "zHzeHZlW36AQICk2p3RUAglZpjDP1KV91499863690-min.jpg",
		"username": "Elin Strååt",
		"spot": "Bondegatan"
	}
];

/***/ })
],[26]);


// WEBPACK FOOTER //
// static/js/app.809ce4156ba15a615287.js